<script>
import Multiselect from "@vueform/multiselect";
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import appConfig from "@/app.config.json";
import useVuelidate from "@vuelidate/core";
import DropZone from "@/components/widgets/dropZone.vue";
import {helpers, required} from "@vuelidate/validators";
import Loader from "../components/loader.vue";
import api from "@/axios";
import moment from "moment";
import Swal from "sweetalert2";
import {ref} from "vue";
import xmlFormat from "xml-formatter";
import { Workbook } from "exceljs";
import { exportDataGrid } from "devextreme/excel_exporter";
import { saveAs } from "file-saver-es";
import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxSelection,
  DxExport,
  DxStateStoring,
  DxGroupPanel,
  DxGrouping,
  DxPager,
  DxFilterRow,
  DxRemoteOperations,
} from "devextreme-vue/data-grid";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "Compra",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    Multiselect,
    DropZone,
    DxDataGrid,
    DxColumn,
    DxColumnChooser,
    DxColumnFixing,
    DxSelection,
    DxExport,
    DxStateStoring,
    DxGroupPanel,
    DxGrouping,
    DxPager,
    DxFilterRow,
    DxRemoteOperations,
  },
  setup() {
    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0]
    };
    const selectedFile = () => {
      dropzoneFile.value = document.querySelector(".dropzoneFile").files[0]
      console.log('selectedFile')

      let arquivo = document.querySelector(".dropzoneFile").files[0]
      console.log(arquivo)

    };
    return { dropzoneFile, drop, selectedFile, v$: useVuelidate() };
  },
  data() {
    return {
      showEspelhoNf: false,
      justificativaCanc: '',
      justificativaCorr: '',
      showModalCancFocusNfe: false,
      showModalCorrFocusNfe: false,
      tipoConsultaFocusNFe: false,
      modalConsultaSimplificada: false,
      retornoConsultaFocusNFe: {},
      modalRetornoEnvioFocusnfe: false,
      statusFocusnfe: '',

      showModalDesconto: false,
      userLogged: null,

      showModalEmissao: false,
      loadingFinConta: false,
      showModalFinConta: false,
      dtListPesqFinConta: null,
      finContaData: null,

      showModalFrete: false,

      showModalAnexoList: false,
      showModalAnexo: false,
      submittedAnexo: false,
      descranexo: '',
      mediasAnexoData: null,

      ultSepsData: {},
      movCompraItemSepData: {},
      movCompraItemSepDataList: null,
      movCompraItemSepDataDisp: 0,
      showModalSepara: false,
      financeiroData: {},
      showModalMediaJson: false,
      mediaJsonCorpem: {},
      showModalXML: false,
      xmlContent: '1,2,3',
      mediasData: {},
      submitMovCompraItem: false,

      loadingFornec: false,
      loadingCondPgto: false,
      loadingFormaPgto: false,
      loadingPedTipo: false,
      loadingMovCompraItem: false,
      loadingWmsEnder: false,
      loadingFinanc: false,


      dtListPesqFor: null,
      dtListPesqCondPgto: null,
      dtListPesqFormaPgto: null,
      dtlistPesqPedTipo: null,
      dtlistPesqMovCompraItem: null,
      dtListPesqWmsEnder: null,
      dtListPesqConta: null,

      showModalFornecedor: false,
      showModalCondPgto: false,
      showModalFormaPgto: false,
      showModalPedTipo: false,
      showModalMovCompraItem: false,
      showModalObs: false,
      showModalImpXML: false,

      showModalFinanceiroData: false,

      optionList: null,

      movCompraData: {
        id: 0,
        status: "EL",
        formapgto: '10',
        condpgto: '10',
        fornec: '23',
        tipo: '06',
        dtemissao: new Date,
        banco: null,
        banco_id: null,
        consutil: false,

      },
      fornecedorData: {
        codigo: '',
        nome: 'Selecionar Fornecedor',
        cidade: '',
        estado: '',
        tel1: '',
        email: '',
        cnpj: '',
        inscricao: '',
        rua: '',
        bairro: '',
        cep: '',
      },
      condPgtoData: {
        'codigo': '10',
        'descricao': '30 / 60 Dias'
      },
      formaPgtoData: {
        'codigo': '10',
        'descricao': 'Boleto'
      },
      pedTipoData: {
        'codigo': '06',
        'descricao': 'Compra de Mercadoria'
      },
      movCompraItemData: {},
      movCompraItensData: {},
      movCompraItensEspelho: null,
      wmsEnderData: null,
      contaData: {},

      somaPedidosFor: 0,
      ultPedsData: null,
      errosValid: null,

      idData: 0,
      updating: true,
      title: "Editar Compra",
      items: [
        {
          text: "Compras",
          href: "/movcompras/list",
        },
        {
          text: "Editar Compra",
          active: true,
        },
      ],
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        headers: { "My-Awesome-Header": "header value" },
      },
      currentPage: 1,
      pesqTextFilter: '',
      totalItens: 0,

      dtListMovimentos: [],
      movimentoSelected: {},

      naturezaData: {},
      dtlistPesqNatureza: [],

      tipoAssociacaoNota: null,

      showModalAcao: false,
      idRow: null,
      idProd: null,
      Prod: null,
    };
  },
  validations: {
    movCompraItemData: {
      produto: {
        required: helpers.withMessage("Campo produto obrigatório, favor preencher.", required),
      },
      qtd: {
        required: helpers.withMessage("Campo quantidade obrigatório, favor preencher.", required),
      },
      vlrunitliq: {
        required: helpers.withMessage("Campo valor unitário obrigatório, favor preencher.", required),
      },
      vlrtotalliq: {
        required: helpers.withMessage("Campo valor total obrigatório, favor preencher.", required),
      },
    }
  },
  watch: {
    'movCompraItemData.qtd': {
      handler() {
        this.calculaTotalItem()
      }
    },
    'movCompraItemData.vlrunitliq': {
      handler() {
        this.calculaTotalItem()
      }
    },
  },
  mounted() {

    this.userLogged = JSON.parse(localStorage.getItem('user'))

    console.log('mounted_movCompra_editar_0')
    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)

    if (this.idData > 0){
      this.carregarDados()
    }else{
      this.title = `Criando Nova Solicitação de Compra`
      this.updating = false
      let emprAtu = localStorage.getItem('empratu')
      this.movCompraData.empresa = emprAtu
    }

  },

  methods:{
    alterarSelecaoNotaMovCompra(){
      console.log('alterarSelecaoNotaMovCompra')

      if(this.tipoAssociacaoNota === 'custom'){
        this.tipoAssociacaoNota = 'movcompra'
      } else{
        this.tipoAssociacaoNota = 'custom'
      }
    },

    removerCodMovCompra() {
      console.log('removerCodMovCompra')

      this.movCompraData.codigo = null
      this.salvar()
    },

    removerNotaAssoc() {
      console.log('removerNotaAssoc')

      this.movCompraData.cnf = null
      this.movimentoSelected = {}
      this.salvar()
    },

    associouMovimento(evt) {
      console.log('associouMovimento')
      console.log(evt)

      if (this.movCompraData.status === 'CO') {
        Swal.fire({
            position: "top-end",
            icon: "error",
            title: "Status não permite edição de MovCompra!",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            return
          })
      }else{
        this.movimentoSelected = this.optionList.find(mov => mov.codigo === evt)
        console.log(this.movimentoSelected)

        this.movCompraData.cnf = evt
        this.salvar()
      }
    },

    pesqMovimento(evt) {
      console.log('pesquisandoMovimento')

      const fornecedorCnpj = this.movCompraData.fornec
      let query = evt

      console.log(query.length)
      if (query.length > 1 && fornecedorCnpj ){
        api.get(`${getBaseUrl()}api/movCompraPesq`, {
          params: {
            q: query,
            fornec: fornecedorCnpj
          }
        }).then((res) => {
          console.log('then axios movpesq')
          if (typeof res.data[0] === 'string') {
            Swal.fire({
              position: "top-end",
              icon: "warning",
              title: res.data[0],
              showConfirmButton: false,
              timer: 2000
            });
            this.optionList = [];
          } else {
            this.optionList = res.data ?? [];
          }
        }).catch(error => {
          console.error("Erro na requisição:", error);
          this.optionList = [];
        });
      } else {
        this.optionList = [];
      }
    },

    //**** Pablo => Início implementação focusnfe
    updateMovCompra(){
      console.log('updateMovCompra')

      api.post(`${getBaseUrl()}api/updMovCompra`,  {
        movcompra: this.movCompraData,
        fornecedor: this.fornecedorData,
        pedtipo: this.naturezaData,
        movcompraitens: this.movCompraItensEspelho
      }).then((res) => {

        console.log(res)

        if(res.data.success){
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: res.data.mensagem,
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.atualizaPagina()
          })
        }else{
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: 'Pedido não pôde ser atualizado',
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.atualizaPagina()
          })
        }
      })
    },

    downloadDanfeFocusnfe(){
      console.log('downloadPdfFocusnfe');

      api.post(`${getBaseUrl()}api/baixardanfe`, {
        iddata: this.idData,
        tabela: 'movcompra'
      }).then((res) => {
        console.log('then axios');
        console.log(res);

        if (res.data.success === false) {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: res.data.mensagem,
            showConfirmButton: false,
            timer: 3000
          })
        } else {
          console.log(this.pedidoData)
          const pdfData = res.data;

          const url = window.URL.createObjectURL(new Blob([pdfData]));

          const a = document.createElement('a');
          a.href = url;
          a.download = this.movCompraData['chave'] + '.pdf';
          document.body.appendChild(a);
          a.click();

          window.URL.revokeObjectURL(url);
        }
      })
    },

    downloadXmlFocusnfe() {
      console.log('downloadXmlFocusnfe')

      api.post(`${getBaseUrl()}api/baixarxml`, {
        iddata: this.idData,
        tabela: 'movcompra'
      }).then((res) => {
        console.log('then axios');
        console.log(res);

        if (res.data.success === false) {
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: res.data.mensagem,
            showConfirmButton: false,
            timer: 3000
          })
        } else {
          const xmlData = res.data;

          const url = window.URL.createObjectURL(new Blob([xmlData]));

          const a = document.createElement('a');
          a.href = url;
          a.download = this.movCompraData['chave'] + '.xml';
          document.body.appendChild(a);
          a.click();

          window.URL.revokeObjectURL(url);
        }
      })
    },

    atualizaPagina(){
      window.location.reload();
    },

    enviarFocusNFe(){
      console.log('enviarFocusNFe')
      //Rota para gerar faturamento da nota fiscal

      api.post(`${getBaseUrl()}api/compfocusnfe`,  {
        iddata: this.idData,
      }).then((res) => {
        console.log('then axios')
        console.log(res)

        this.popupEnvioFocusNFe(res)
      })
    },

    popupEnvioFocusNFe(res){
      console.log('popupEnvioFocusNFe')
      this.retornoConsultaFocusNFe = res.data

      if(this.retornoConsultaFocusNFe.success == true){
        Swal.fire({
          position: "top-end",
          icon: "info",
          title: "Envio de NF-e sucedido!",
          showConfirmButton: false,
          timer: 3000
        })

        this.modalRetornoEnvioFocusnfe = true

      }else{
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: "Envio de NF-e mal sucedido!",
          showConfirmButton: false,
          timer: 3000
        });
        //Apresentando erro gerado ao enviar a nota fiscal
        this.modalRetornoEnvioFocusnfe = true
      }
    },

    consultarFocusNFe(tipo){
      console.log('Consultar FocusNFe')

      api.post(`${getBaseUrl()}api/consfocusnfe`,  {
        iddata: this.idData,
        tipoConsulta: tipo,
        tabela: 'movcompra'
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        this.statusFocusnfe = res.data

        this.retornoConsultaFocusNFe = res.data
        this.tipoConsultaFocusNFe = false
        this.modalConsultaSimplificada = true
      })
    },

    //Envio de carta de correção de uma determinada nota fiscal
    confirmarCorrFocusNfe(){
      console.log('confirmarCorrFocusNfe')

      api.post(`${getBaseUrl()}api/corrfocusnfe`, {
        iddata: this.idData,
        justificativa: this.justificativaCorr,
        tabela: 'movcompra'
      }).then((res) => {
        console.log('then axios');
        console.log(res);

        if(res.data.success === true){
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: res.data.detalhes,
            showConfirmButton: false,
            timer: 3000
          }).then(
              this.atualizaPagina()
          )

        }else{
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: res.data.detalhes,
            showConfirmButton: false,
            timer: 3000
          })
        }

        this.showModalCorrFocusNfe = false
      })
    },

    //Cancelamento de uma nota fiscal
    confirmarCancFocusNfe(justificativaCanc) {
      console.log('cancelarFocusNFe');
      console.log(justificativaCanc);

      api.post(`${getBaseUrl()}api/cancfocusnfe`, {
        iddata: this.idData,
        justificativa: this.justificativaCanc,
        tabela: 'movcompra'
      }).then((res) => {
        console.log('then axios');
        console.log(res);

        if(res.data.success === true){
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: res.data.detalhes,
            showConfirmButton: false,
            timer: 3000
          }).then(
              this.atualizaPagina()
          )

        }else{
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: res.data.detalhes,
            showConfirmButton: false,
            timer: 3000
          })
        }


        this.showModalCancFocusNfe = false;
      })

    },
    // **** Pablo => Fim da implementação focusnfe

    editarFinanceiro() {
      console.log('editarFinanceiro')

      this.showModalFinanceiroData = true;
    },

    editarNatureza() {
      console.log('editarNatureza')

      if (this.movCompraData.status === 'EL') {
        console.log(this.movCompraData.tipo)
        this.showModalPedTipo = true
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de compra não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    confirmarFinanceiro() {
      console.log('confirmarFinanceiro')

      const movCompraData = this.movCompraData

      this.movCompraData.condpgto = movCompraData.condpgto
      this.movCompraData.formapgto = movCompraData.formapgto
      this.movCompraData.banco_id = movCompraData.banco_id
      this.movCompraData.consutil = movCompraData.consutil

      this.showModalFinanceiroData = false
      
      /**
       * Salvamento automático
       */
      this.salvar()
    },

    gerarWmsOs() {
      console.log('gerarWmsOs')

      api.get(`${getBaseUrl()}api/movcomprawmsos`, {
        params: { idData: this.movCompraData.id }
      }).then((res) => {
        console.log('then axios gerar_wms_os')
        console.log(res.data)


        // this.condPgtoData = res.data[0]
        // this.ultPedsData = res.data[1]
        //
        // let totalPed = 0
        // this.ultPedsData.forEach((value) => {
        //   totalPed += value.valorliq
        // });
        //
        // this.somaPedidosCli = totalPed
        // this.loadingCondPgto = false
      })

    },


    gerarSaldo() {
      console.log('gerarSaldo')

      this.updating = true
      api.post(`${getBaseUrl()}api/mvcompragerasld`, {
        iddata: this.idData
      }).then((res) => {
        console.log('then axios gerar saldo')
        console.log(res)

      })


    },

    gerarFinanc() {
      console.log('gerarFinanc')

      this.updating = true
      api.post(`${getBaseUrl()}api/mvcompragerafin`, {
        iddata: this.idData
      }).then((res) => {
        console.log('then axios gerar financ')
        console.log(res)

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })

        this.updating = false

      })


    },


    pesqFinConta(evt){
      console.log('pesqFinConta')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/fcontapesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqFinConta = res.data
        });
      }
    },

    escolheuFinConta(){
      console.log('escolheuFinConta')
      console.log(this.movCompraData.conta)
      api.get(`${getBaseUrl()}api/fconta`, {
        params: { coddata: this.movCompraData.finconta }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.finContaData = res.data[0]

      })
    },


    alteraFrete(){
      console.log('alteraFrete')
      if (this.movCompraData.status === 'EL'){
        this.showModalFrete = true
      }else{
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de orçamento não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    confirmarFrete(){
      console.log('confirmarFrete')
      this.showModalFrete = false
      this.salvar()

    },

    confirmarDesconto(){
      console.log('confirmarDesconto')
      this.showModalDesconto = false
      this.salvar()

    },

    delFile(dataID){
      console.log('deletar: ' + dataID)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          this.loadingFiles = true

          api.delete(`${getBaseUrl()}api/media`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })

            this.loadingFiles = false
            this.mediasAnexoData = res.data[0]
          })


        }
      })
    },


    downFile(path, nomeArq){
      console.log('downFile: ' + path)
      //console.log('downFile: ' + path.split('.').pop())

      this.loadingFiles = true
      api.get(`${getBaseUrl()}api/getfile`, {
        responseType: 'blob',
        params: { pathData: path }
      }).then((res) => {
        console.log('res down')
        console.log(res)

        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', nomeArq);
        document.body.appendChild(fileLink);

        console.log('fileLink')
        console.log(fileURL)

        fileLink.click();
        this.loadingFiles = false
      })



    },


    novoAnexo(){
      console.log('novoAnexo')
      this.descranexo = ''
      this.submittedAnexo = false
      this.showModalAnexo = true
      // this.activeTab = 2
    },



    confAnexo(){
      console.log('confAnexo')
      this.submittedAnexo = true
      if (this.descranexo !== '' && this.dropzoneFile.name){
        this.showModalAnexo = false
        this.loadingFiles = true

        let arquivo = document.querySelector(".dropzoneFile").files[0]
        console.log(arquivo)
        let formData = new FormData()
        formData.append("iddata", this.idData)
        formData.append("descranexo", this.descranexo)
        formData.append("filename", arquivo.name)
        formData.append("file", arquivo)

        api.post(`${getBaseUrl()}api/mvcpfile`,formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.mediasAnexoData = res.data[0]
          this.loadingFiles = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })

        }).catch((err) => {

          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.loadingFiles = false
        })
      }
    },


    informouQtd() {
      console.log('informouQtd')
      console.log(this.movCompraItemSepData.qtd)

      console.log(this.movCompraItemSepDataDisp)

      if (this.movCompraItemSepData.qtd > 0  && this.movCompraItemSepData.qtd <= this.movCompraItemSepDataDisp && this.movCompraItemSepData.palete && this.movCompraItemSepData.endwms){
        this.confirmarSeparacao()
      }

      // this.movCompraItemSepDataDisp = 32
      //
      // this.loadingWmsEnder = true
      //
      // api.post(`${getBaseUrl()}api/movcpitconfsep`, {
      //   'movCompraItemSepData': this.movCompraItemSepData,
      // }).then((res) => {
      //   console.log('then axios separar1')
      //   console.log(res.data)
      //
      //
      //
      //
      //   // this.movCompraItemData.stswms = 'SE'
      //   //
      //   // //this.movCompraData = res.data
      //   // // this.idData = res.data[0].id
      //   // // this.$router.replace({ path: `/movcompra/editar/${this.idData}` })
      //   // // this.carregarDados()
      //   // // this.carregarDadosItens()
      //   // this.showModalSepara = false
      //
      //   Swal.fire({
      //     position: "top-end",
      //     icon: "success",
      //     title: "Separação confirmada com sucesso!",
      //     showConfirmButton: false,
      //     timer: 1500
      //   })
      // })


    },

    informouPalete() {
      console.log('informouPalete')
      this.$refs.qtdsep.focus()

      api.get(`${getBaseUrl()}api/wmsendcod`, {
        params: {coddata: this.movCompraItemSepData.palete}
      }).then((res) => {
        console.log('then axios endwms')
        console.log(res.data)

        if (res.data[0]){
          this.movCompraItemSepData.endwms = res.data[0]['descricao']
        }



      })



    },



    confirmarSeparacao() {
      console.log('confirmarSeparacao')

      this.loadingWmsEnder = true

      this.movCompraItemSepData.movcompraitem_id = this.movCompraItemData.id
      this.movCompraItemSepData.und = this.movCompraItemData.und
      this.movCompraItemSepData.vlrunitliq = this.movCompraItemData.vlrunitliq
      this.movCompraItemSepData.vlrtotalliq = this.movCompraItemData.vlrtotalliq
      this.movCompraItemSepData.desconto = this.movCompraItemData.desconto
      this.movCompraItemSepData.lote = this.movCompraItemData.lote
      this.movCompraItemSepData.dtfabric = this.movCompraItemData.dtfabric
      this.movCompraItemSepData.dtvalid = this.movCompraItemData.dtvalid


      console.log(this.movCompraItemSepData)

      api.post(`${getBaseUrl()}api/movcpitconfsep`, {
        'movCompraItemSepData': this.movCompraItemSepData
      }).then((res) => {
        console.log('then axios separar2')
        console.log(res.data)

        this.movCompraItemSepDataList = res.data[0]
        this.movCompraItemData = res.data[1]
        this.loadingWmsEnder = false

        let valorSeparado = 0
        this.movCompraItemSepDataList.forEach((value) => {
          valorSeparado += value.qtd
        })
        this.movCompraItemSepDataDisp = this.movCompraItemData.qtd - valorSeparado

        if (this.movCompraItemSepDataDisp === 0){
          this.showModalSepara = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Separação salva com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.carregarDados()

        } else {
          this.movCompraItemSepData.qtd = this.movCompraItemSepDataDisp
          this.movCompraItemSepData.palete = ''
          this.movCompraItemSepData.endwms = ''
          this.$refs.palete.focus()
        }




        // this.movCompraItemData.stswms = 'SE'
        //
        //this.movCompraData = res.data
        // this.idData = res.data[0].id
        // this.$router.replace({ path: `/movcompra/editar/${this.idData}` })
        // this.carregarDados()
        // this.carregarDadosItens()
        // this.showModalSepara = false
        //

      })




    },


    enderecarProduto(itemData){
      console.log('enderecarProduto')
      this.movCompraItemData = itemData

      api.get(`${getBaseUrl()}api/movcpitconfsep`, {
        params: {idData: this.movCompraItemData.id}
      }).then((res) => {
        console.log('then axios separa')
        console.log(res.data)

        this.movCompraItemSepDataList = res.data[0]

        let valorSeparado = 0
        this.movCompraItemSepDataList.forEach((value) => {
          valorSeparado += value.qtd
        })
        this.movCompraItemSepDataDisp = this.movCompraItemData.qtd - valorSeparado
        this.movCompraItemSepData.qtd = this.movCompraItemSepDataDisp

        this.showModalSepara = true

        // this.$refs.palete.focus()

        // this.mediaJsonCorpem = res.data[0]
        //
        // Swal.fire({
        //   position: "top-end",
        //   icon: "success",
        //   title: "Integração Realizada com Sucesso",
        //   text: this.mediaJsonCorpem.objretorno,
        //   showConfirmButton: false,
        //   timer: 2500
        // })

        this.updating = false

      })




    },


    onPageChange(){
      console.log('onPageChange')
      console.log(this.currentPage)
      this.carregarDados()
    },

    abrirFinanceiro(){
      console.log('abrirFinanceiro')

      const routeData = this.$router.resolve(`/cpagar/editar/${this.financeiroData.id}`)
      window.open(routeData.href, '_blank')

    },

    copiarXML(){
      console.log('copiarXML')

      try {
        navigator.clipboard.writeText(this.xmlContent);
        this.showModalXML = false

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Conteúdo do arquivo XML disponível na sua área de transferência.",
          showConfirmButton: false,
          timer: 1500
        })

      } catch ($e) {
        console.log('erro ao copiar objeto')
        console.log($e)
      }

    },


    integrCorpem() {
      console.log('integrCorpem')

      if (this.mediaJsonCorpem && this.mediaJsonCorpem.id) {
        this.showModalMediaJson = true
      } else {
        this.updating = true

        api.get(`${getBaseUrl()}api/spnfentr`, {
          params: {idData: this.idData}
        }).then((res) => {
          console.log('then axios integr')
          console.log(res.data)
          this.mediaJsonCorpem = res.data[0]

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Integração Realizada com Sucesso",
            text: this.mediaJsonCorpem.objretorno,
            showConfirmButton: false,
            timer: 2500
          })

          this.updating = false

        })

      }

    },


    confirmarXML() {
      console.log('confirmarXML')
      this.showModalImpXML = false
      this.$router.replace({
        path: `/nota/editar/0`,
        params: this.selectedFile
      })
    },

    visualizarXML() {
      console.log('visualizarXML')
      this.updating = true
      api.get(`${getBaseUrl()}api/getfile`, {
        responseType: 'blob',
        params: {pathData: this.mediasData[0].path}
      }).then((res) => {

        const reader = new FileReader()
        reader.addEventListener('loadend', (e) => {
          const text = e.srcElement.result
          this.xmlContent = xmlFormat(text, {
            indentation: '  ',
            filter: (node) => node.type !== 'Comment',
            collapseContent: true,
            lineSeparator: '\n'
          })
          this.showModalXML = true
        })
        reader.readAsText(res.data)

        this.updating = false
      })


    },


    copiar() {
      console.log('copiar')
      this.updating = true
      api.post(`${getBaseUrl()}api/movcompracopy`, {
        'iddata': this.idData
      }).then((res) => {
        console.log('then axios copiar')
        console.log(res.data[0].id)
        //this.movCompraData = res.data

        this.idData = res.data[0].id
        this.$router.replace({path: `/movcompra/editar/${this.idData}`})
        this.carregarDados()

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Movimento copiado com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })
      })

    },

    deletarMovCompraItem(iditem) {
      console.log('deletarMovCompraItem')
      console.log(iditem)

      if (this.movCompraData.status === 'EL') {
        Swal.fire({
          position: "center",
          icon: "question",
          title: "Exclusão de Registro",
          text: "Esta operação é irreversível, tem certeza que deseja continuar?",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
          showConfirmButton: true,

        }).then(result => {
          if (result.value) {
            this.updating = true
            api.delete(`${getBaseUrl()}api/movcompraitem`, {
              params: {
                'iddata': iditem
              }
            }).then((res) => {
              console.log('then axios delete')
              console.log(res.data)
              this.showModalAcao = false
              this.carregarDados()
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Informações excluídas com sucesso!",
                showConfirmButton: false,
                timer: 1500
              })
            })

          }
        })
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de compra não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    calculaTotalItem() {
      console.log('calculaTotalItem')

      let quant = this.movCompraItemData.qtd
      let vlrUnit = this.movCompraItemData.vlrunitliq
      let vlrUnitTab = this.movCompraItemData.vlrunitliq
      // let percDesc = 0

      if (quant > 0 && vlrUnit > 0) {

        let valorTotalItem = quant * vlrUnit
        console.log('valorTotalItem')
        console.log(valorTotalItem)

        // if (vlrUnit !== vlrUnitTab){
        // percDesc = (1 - (vlrUnit / vlrUnitTab)) * 100
        // }


        this.movCompraItemData.desconto = 0
        this.movCompraItemData.vlrtotalbrt = vlrUnitTab * quant
        this.movCompraItemData.vlrtotalliq = valorTotalItem
      }

    },

    confMovCompraItem() {
      console.log('confMovCompraItem: ' + this.idData)
      this.v$.$touch()
      this.submitMovCompraItem = true

      if (this.v$.$invalid) {
        return;
      } else {
        console.log('formSubmit_validado')
        this.movCompraItemData.empresa = this.movCompraData.empresa
        this.loadingMovCompraItem = true

        api.post(`${getBaseUrl()}api/movcompraitem`, {
          movCompraItemData: this.movCompraItemData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.produtoData = res.data[0]
          this.updating = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.loadingMovCompraItem = false
          this.showModalMovCompraItem = false
          this.carregarDados()

        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
          this.activeTab = 0
        })

      }
    },

    novoProduto() {
      console.log('novoProduto: ' + this.idData)

      if (this.idData === 0) {

        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor salvar a compra antes de adicionar item",
          showConfirmButton: false,
          timer: 1500
        })

      } else {
        this.movCompraItemData = {}
        this.showModalMovCompraItem = true
      }


    },

    detalhesProduto(idProd) {
      console.log('detalhesProduto: ' + idProd)
      this.showModalAcao = false
      this.$router.push(`/produto/editar/${idProd}`)

      // let route = this.$router.resolve({ path: "/contact" });
      // window.open(route.href);


    },

    editarProduto(idProd) {
      console.log('editarProduto: ' + idProd)

      if (this.movCompraData.status === 'EL') {
        this.showModalAcao = false
        this.showModalMovCompraItem = true
        this.loadingMovCompraItem = true

        api.get(`${getBaseUrl()}api/movcompraitem`, {
          params: {iddata: idProd}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data[0])

          this.movCompraItemData = res.data[0]

          if (this.movCompraItemData.imgs) {
            let imgTrat = this.movCompraItemData.imgs.split(',')
            this.movCompraItemData.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
          }

          this.loadingMovCompraItem = false
        })
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de compra não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    confirmar() {
      console.log('confirmar: ' + this.idData)

      if (this.movCompraData.fornec && this.movCompraData.fornec !== '') {
        if (!this.movCompraItensData || this.movCompraItensData.length <= 0) {
          Swal.fire({
            position: "top-end",
            icon: "warning",
            title: "Favor adicionar produto a compra antes de confirmar",
            showConfirmButton: false,
            timer: 1500
          })
        } else {
          Swal.fire({
            position: "center",
            icon: "question",
            title: "Confirmação de Compra",
            text: "Esta operação é irreversível, tem certeza que deseja continuar?",
            confirmButtonText: "Confirmar",
            cancelButtonText: "Cancelar",
            showCancelButton: true,
            showConfirmButton: true,
          }).then(result => {
            if (result.value) {
              this.updating = true
              api.post(`${getBaseUrl()}api/movcompraconf`, {
                iddata: this.idData
              }).then((resConf0) => {
                console.log('then axios confirmar:')
                console.log(resConf0)

                if(!resConf0.data.success){
                  console.log('erro confirmação de compra...')

                  Swal.fire({
                    position: "top-end",
                    icon: "error",
                    title: resConf0.data.error,
                    showConfirmButton: false,
                    timer: 2500
                  }).then(() => {
                    this.carregarDados()
                  })
                }else{
                  this.updating = false
                  Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: "Compra confirmada com sucesso",
                    showConfirmButton: false,
                    timer: 1500
                  }).then(() => {

                    let idWmsOs = resConf0.data.wmsos_id

                    if (idWmsOs > 0) {
                      this.$router.push(`/wmsos/entradaeditarnova/${idWmsOs}`)
                    } else {
                      this.$router.push(`/movcompras/list`)
                    }
                  })
                }
              })
            }
          })
        }
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Favor selecionar fornecedor antes de salvar a compra",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    cancelar() {
      console.log('cancelar: ' + this.idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Cancelamento de Compra",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {

          if (this.idData > 0) {
            this.updating = true
            api.post(`${getBaseUrl()}api/movcompracanc`, {
              iddata: this.idData
            }).then((res) => {
              console.log('then axios')
              console.log(res)
              this.movCompraData = res.data[0]
              this.updating = false
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Compra cancelada com sucesso!",
                showConfirmButton: false,
                timer: 1500
              })
            })
          } else {
            this.$router.go(-1)
          }


        }
      })
    },

    nomeStatus(stsIn) {
      let result = 'Não Definido'
      switch (stsIn) {
        case 'EL':
          result = 'Elaboração'
          break
        case 'FA':
          result = 'Faturado'
          break
        case 'CA':
          result = 'Cancelado'
          break
        case 'CO':
          result = 'Confirmado'
          break;
        case 'AG':
          result = 'Agendado Sefaz'
          break;
        case 'AT':
          result = 'Aprovado Sefaz'
          break
      }
      return result
    },

    nomeStatusWms(stsIn) {
      let result = 'Não Separado'
      switch (stsIn) {
        case 'SE':
          result = 'Separado'
          break
      }
      return result
    },


    alteraObs() {
      console.log('alteraObs')
      if (this.movCompraData.status === 'EL') {
        this.showModalObs = true
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de compra não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    gerarFinanceiro() {
      api.get(`${getBaseUrl()}api/criarfinancompra`, {
        params: {iddata: this.idData}
      }).then((res) => {
        console.log('then axios get criarfinancompra:')
        console.log(JSON.stringify(res.data))

        if (res.data.success) {
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: res.data.message,
            showConfirmButton: false,
            timer: 2500
          })
        }else{
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: res.data.message,
            showConfirmButton: false,
            timer: 2500
          })
        }
      })
    },

    carregarDados() {
      api.get(`${getBaseUrl()}api/movcompra`, {
        params: {iddata: this.idData}
      }).then((res) => {
        console.log('then axios _movEditar')
        console.log(res)
        console.log(res.data[8])
        this.movCompraData = res.data[0]

        //Verificando se fornecedor
        if(res.data[1]){
          this.fornecedorData = res.data[1]
        }

        this.pedTipoData = res.data[2]
        this.formaPgtoData = res.data[3]
        this.condPgtoData = res.data[4]
        this.movCompraItensData = res.data[5]
        this.movCompraItensEspelho = res.data[5]
        this.mediasData = res.data[6]
        this.mediaJsonCorpem = res.data[7]
        this.financeiroData = res.data[8]
        this.mediasAnexoData = res.data[9]
        this.finContaData = res.data[10]
        this.naturezaData = res.data[12]


        this.movCompraData.dtemissao_fmt = moment(this.movCompraData.dtemissao).format('DD/MM/YYYY')

        if (res.data[15] && res.data[15].codigo !== null){
          this.optionList = res.data[15]
        }
        if (res.data[11] !== null && res.data[11].codigo !== null) {

          this.dtListMovimentos = res.data[11]

          if(this.dtListMovimentos.tipoAssociacaoNota === 'movcompra'){
            this.tipoAssociacaoNota = this.dtListMovimentos.tipoAssociacaoNota

            this.movimentoSelected =  this.dtListMovimentos
          } else {
            this.tipoAssociacaoNota = this.dtListMovimentos.tipoAssociacaoNota
          }
        }

        if(this.condPgtoData && this.condPgtoData.id){
          this.dtListPesqCondPgto = [
            {
              id: this.condPgtoData.id,
              codigo: this.condPgtoData.codigo,
              descricao: this.condPgtoData.descricao,
            }
          ]
        }

        if(this.formaPgtoData && this.formaPgtoData.id){
          this.dtListPesqFormaPgto = [
            {
              id: this.formaPgtoData.id,
              codigo: this.formaPgtoData.codigo,
              descricao: this.formaPgtoData.descricao,
            }
          ]
        }

        this.contaData = res.data[13]

        if(this.contaData && this.contaData.id){
          this.dtListPesqConta = [
            {
              id: this.contaData.id,
              banco: this.contaData.banco,
              descricao: this.contaData.descricao,
            }
          ]
        }


        // if (this.movCompraItensData && this.movCompraItensData.length > 0){
        //   this.movCompraItensData.forEach((value) => {
        //     if (value.imgs) {
        //       let imgTrat = value.imgs.split(',')
        //       value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
        //       let valor = parseFloat(value.vlrtotalliq)
        //       this.valorTotalItens += valor
        //     }
        //   });
        // }

        this.idData = this.movCompraData.id
        this.title = `Editar Movimento de Compra (${this.movCompraData.id}) ${this.fornecedorData != null ? this.fornecedorData.nome : ''}`
        this.updating = false
      })

      // api.get(`${getBaseUrl()}api/movcomprait`, {
      //   params: { iddata: this.idData }
      // }).then((res) => {
      //
      //   console.log('res itens')
      //   console.log(res)
      //   this.movCompraItensData = res.data
      //
      // })

    },


    carregarDadosItens() {
      console.log('carregarDadosItens')
      this.updating = true

      api.get(`${getBaseUrl()}api/movcomprait?page=${this.currentPage}`, {
        params: {
          iddata: this.idData,
          'q': this.pesqTextFilter,
        }
      }).then((res) => {

        console.log('res itens')
        console.log(res)
        this.totalItens = (res.data.total + 2) * 10
        this.movCompraItensData = res.data.data
        this.updating = false

        console.log('this.totalItens')
        console.log(this.totalItens)

      })

    },

    selecionaCli() {
      console.log('selecionaCli')
      if (this.movCompraData.status === 'EL') {
        this.showModalFornecedor = true
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de compra não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    /*selecionaCondPgto() {
      console.log('selecionaCondPgto')
      if (this.movCompraData.status === 'EL') {
        this.showModalCondPgto = true
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de compra não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    selecionaFormaPgto() {
      console.log('selecionaFormaPgto')
      if (this.movCompraData.status === 'EL') {
        this.showModalCondPgto = true
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de compra não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },*/
    selecionaPedTipo() {
      console.log('selecionaPedTipo')
      //Pablo => Anteriormente apenas pedidos em EL poderiam ser editados. Ajustei para que outros status também possam
      if (this.movCompraData.status === 'EL') {
        console.log(this.movCompraData.tipo)
        this.showModalPedTipo = true
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de compra não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },
    selecionaMovCompraItem() {
      console.log('selecionaMovCompraItem')
      if (this.movCompraData.status === 'EL') {
        this.showModalMovCompraItem = true
      } else {
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de compra não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
      }
    },

    confirmarFornec() {
      console.log('confirmarFornec')
      this.showModalFornecedor = false
      this.salvar()
    },
    confirmarCondPgto() {
      console.log('confirmarCondPgto')
      this.showModalCondPgto = false
    },
    confirmarFormaPgto() {
      console.log('confirmarFormaPgto')
      this.showModalCondPgto = false
    },
    confirmarPedTipo() {
      console.log('confirmarPedTipo')
      this.showModalPedTipo = false
    },
    confirmarMovCompraItem() {
      console.log('confirmarMovCompraItem')
      this.showModalMovCompraItem = false
    },

    pesqFornec(evt) {
      console.log('pesqFornec')
      console.log(evt)
      let query = evt
      if (query.length > 1) {
        api.get(`${getBaseUrl()}api/clipesq`, {
          params: {q: query, c: 'FO'}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqFor = res.data
        });
      }
    },

    pesqConta(evt){
      console.log('pesqFinConta')
      console.log(evt)
      let query = evt
      if (query.length > 1){
        this.loadingFinanc = true;
        api.get(`${getBaseUrl()}api/ccontapesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          this.dtListPesqConta = res.data
          this.dtListPesqConta.sort((a,b) => a.codigo - b.codigo);
        });
      }
    },

    pesqCondPgto(evt) {
      console.log('pesqCondPgto')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1) {
        this.loadingCondPgto = true
        this.loadingFinanc = true;
        this.movCompraData.condpgto = ''
        api.get(`${getBaseUrl()}api/cpgtopesq`, {
          params: {q: query}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqCondPgto = res.data
        })
      }
    },

    pesqFormaPgto(evt) {
      console.log('pesqFormaPgto')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1) {
        this.loadingFormaPgto = true
        this.loadingFinanc = true;
        this.movCompraData.formapgto = ''
        api.get(`${getBaseUrl()}api/fpgtopesq`, {
          params: {q: query}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqFormaPgto = res.data
        })
      }
    },

    pesqWmsEnder(evt) {
      console.log('pesqWmsEnder')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1) {
        this.loadingWmsEnder = true
        this.movCompraItemData.endwms = ''
        api.get(`${getBaseUrl()}api/wmsendpesq`, {
          params: {q: query}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqWmsEnder = res.data
        })
      }
    },

    pesqPedTipo(evt) {
      console.log('pesqPedTipo')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1) {
        this.loadingPedTipo = true
        this.movCompraData.tipo = ''
        api.get(`${getBaseUrl()}api/tpoprpesq`, {
          params: {q: query, t: 'E', f: this.movCompraData.empresa}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtlistPesqPedTipo = res.data
        })
      }
    },

    pesqMovCompraItem(evt) {
      console.log('pesqMovCompraItem')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1) {
        this.dtlistPesqMovCompraItem = null
        this.loadingMovCompraItem = true
        api.get(`${getBaseUrl()}api/prodpesq`, {
          params: {q: query}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          // //console.log(res.data.length)
          this.dtlistPesqMovCompraItem = res.data

          this.dtlistPesqMovCompraItem.forEach((value) => {
            let imgTrat = value.imgs.split(',')
            value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
          });

        })
      }
    },

    escolheuFor() {
      console.log('escolheuFor')
      this.loadingFornec = true
      console.log(this.movCompraData.fornec)
      api.get(`${getBaseUrl()}api/clicod`, {
        params: {coddata: this.movCompraData.fornec}
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.fornecedorData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosFor = totalPed
        this.loadingFornec = false
        this.optionList = [];
      })
    },

    escolheuConta() {
      console.log('selectedContaData')
      this.loadingFinanc = true;
      console.log(this.movCompraData.banco_id);
      api.get(`${getBaseUrl()}api/cconta`, {
        params: { iddata: this.movCompraData.banco_id },
      }).then((res) => {
        console.log("then axios");
        // console.log(res.data);
        this.ContaData = res.data[0];

        this.loadingFinanc = false;
        this.movCompraData.banco_id = this.ContaData.id;
        this.movCompraData.banco = this.ContaData.banco;
      });
    },

    escolheuCondPgto() {
      console.log('escolheuCondPgto')
      this.loadingCondPgto = true
      this.loadingFinanc = true
      console.log(this.movCompraData.condpgto)
      api.get(`${getBaseUrl()}api/cpgtocod`, {
        params: {coddata: this.movCompraData.condpgto}
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.condPgtoData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.movCompraData.condpgto = this.condPgtoData.codigo

        this.somaPedidosFor = totalPed
        this.loadingCondPgto = false
        this.loadingFinanc = false
      })
    },

    escolheuFormaPgto() {
      console.log('escolheuFormaPgto')
      this.loadingFormaPgto = true
      this.loadingFinanc = true
      console.log(this.movCompraData.formapgto)
      api.get(`${getBaseUrl()}api/fpgtocod`, {
        params: {coddata: this.movCompraData.formapgto}
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.formaPgtoData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.movCompraData.formapgto = this.formaPgtoData.codigo

        this.somaPedidosFor = totalPed
        this.loadingFormaPgto = false
        this.loadingFinanc = false
      })
    },

    escolheuWmsEnder() {
      console.log('escolheuWmsEnder')
      this.loadingWmsEnder = true

      console.log('this.movCompraItemData.endwms')
      console.log(this.movCompraItemData.endwms)

      api.get(`${getBaseUrl()}api/wmsendcod`, {
        params: {coddata: this.movCompraItemData.endwms}
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.wmsEnderData = res.data[0]
        // this.ultPedsData = res.data[1]

        // let totalPed = 0
        // this.ultPedsData.forEach((value) => {
        //   totalPed += value.valorliq
        // });

        // this.somaPedidosFor = totalPed
        this.loadingWmsEnder = false
        //this.showModalSepara = false
      })
    },

    escolheuPedTipo() {
      console.log('escolheuPedTipo')
      this.loadingPedTipo = true
      console.log(this.movCompraData.tipo)
      api.get(`${getBaseUrl()}api/tpoprcod`, {
        params: {coddata: this.movCompraData.tipo}
      }).then((res) => {
        console.log('then axios_escolheu_ped_tipo')
        console.log(res.data)
        this.pedTipoData = res.data[0]
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosFor = totalPed
        this.loadingPedTipo = false
      })
    },

    escolheuNatureza(){
      console.log('escolheuNatureza')

      if (Array.isArray(this.dtlistPesqNatureza) && this.dtlistPesqNatureza.length > 0) {
        this.naturezaData = this.dtlistPesqNatureza.find((natureza) => {
          if (natureza.id === this.movCompraData.tipo) {
            console.log('natureza selected:')
            console.log(natureza)

            return natureza
          }
        })

        console.log('naturezaData:')
        console.log(this.naturezaData)

        this.loadingPedTipo = false
        this.movCompraData.tipo = this.naturezaData.id
        console.log('movCompraData.tipo: ' + this.movCompraData.tipo)
        if (this.movCompraData.tipo !== null && this.movCompraData.tipo !== "") {
          //this.showModalNatureza = false
        }

        this.showModalPedTipo = false
        this.salvar()
      }
    },

    pesqNatureza(evt) {
      console.log('pesqNatureza')
      console.log(evt)

      //console.log('this.movcompraData.status')
      //console.log(JSON.stringify(this.movcompraData))

      if(this.movCompraData.status !== 'EL'){
        Swal.fire({
          position: "top-end",
          icon: "warning",
          title: "Status de compra não permite alteração",
          showConfirmButton: false,
          timer: 1500
        })
        return
      }

      let query = evt
      console.log(query.length)
      if (query.length > 1) {
        this.loadingPedTipo = true
        this.movCompraData.tipo = ''
        api.get(`${getBaseUrl()}api/naturpesq`, {
          params: { q: query, t: 'S', f: this.movCompraData.empresa, tipo: "SA" }
        }).then((res) => {
          console.log('then axios pesqNatureza')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtlistPesqNatureza = res.data
        })
      }
    },

    redirecionarNatureza(){
      console.log('redirect to natureza')

      let url = this.$router.resolve(`/natureza/editar/${this.naturezaData.id}`)
      window.open(url.href, '_blank')
    },

    escolheuMovCompraItem() {
      console.log('escolheuItem')
      this.loadingMovCompraItem = true
      api.get(`${getBaseUrl()}api/prodcod`, {
        params: {coddata: this.movCompraItemData.produto}
      }).then((res) => {
        console.log('then axios_escolheu_ped_item')
        console.log(res.data)
        this.movCompraItemData = {
          movcompra_id: this.idData,
          produto_id: res.data[0]['id'],
          produto: res.data[0]['codigo'],
          descprod: res.data[0]['descricao'],
          und: res.data[0]['unidade'],
          vlrunitliq: res.data[0]['preco'],
          vlrunitbrt: res.data[0]['preco'],
          vlrtotalliq: res.data[0]['preco'],
          vlrtotalbrt: res.data[0]['preco'],
          img1: `${getBaseUrl() + '_IMG'}/peq/${res.data[0]['imgs']}`,
          qtd: 1
        }
        this.ultPedsData = res.data[1]

        let totalPed = 0
        this.ultPedsData.forEach((value) => {
          totalPed += value.valorliq
        });

        this.somaPedidosFor = totalPed
        this.loadingMovCompraItem = false
      })
    },

    salvar() {
      console.log('salvar')

      this.movimentoSelected = {}
      this.updating = true

      this.errosValid = []
      api.post(`${getBaseUrl()}api/movcompra`, {
        movCompraData: this.movCompraData
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        this.movCompraData = res.data[0]
        this.updating = false

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        })

        this.carregarDados()

        if (this.idData === 0) {
          console.log('redirecionar')
          this.$router.replace({path: `/movcompra/editar/${this.movCompraData.id}`})
          this.idData = this.movCompraData.id
        }

      }).catch((err) => {
        console.log('erro axios')
        // console.log(err)
        // console.log(err.response)
        // console.log(err.response.data.errors)
        let erros = err.response.data.errors
        console.log(erros)
        console.log(typeof erros)
        let listaErros = []
        Object.keys(erros).forEach(key => {
          console.log(key, erros[key]);
          listaErros.push({
            'titulo': key,
            'mensagem': erros[key]
          })
        });
        this.errosValid = listaErros
        this.updating = false
        this.activeTab = 0
      })
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 4});
      }
      return "0,00";
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if (value) {
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },
    onRowDblClick(row) {
      console.log("onRowDblClick");

      let idRow = row.data.id;
      let idProd = row.data.produto_id;
      let Prod = row.data.produto;

      this.idRow = idRow;
      this.idProd = idProd;
      this.Prod = Prod;
      // this.editarProduto(idProd);
      this.showModalAcao = true;
    },
    onExporting(e) {
      console.log("onExporting");
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("plan1");
      exportDataGrid({
        component: e.component, 
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            this.title + ".xlsx"
          );
        });
      });
      e.cancel = true;
    },

  }

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" :status="movCompraData.status"/>

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="row" v-if="!updating">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">

              <!-- O GRUPO FESTA PEDIU PARA DESABILITAR A GERAÇÃO DE NOTA FISCAL DE COMPRA POR ENQUANTO - CONFIRMADO PELO EVANDRO (PABLO) -->

              <!-- <b-button variant="outline-primary" class="mx-2" @click="showEspelhoNf = true"
                        v-if="movCompraData.status == 'CO' || movCompraData.status == 'FA' || movCompraData.status == 'NG'">
                <i class="bx bx-message-alt font-size-16 align-middle me-2"></i>
                Consultar espelho nota
              </b-button>

              <b-button variant="outline-success" class="mx-2" @click="enviarFocusNFe"
                        v-if="movCompraData.status == 'CO' || movCompraData.status == 'NG'">
                <i class="bx bx-rocket font-size-16 align-middle me-2"></i>
                Gerar NF e enviar para sefaz
              </b-button>

              <b-button variant="outline-primary" class="mx-2" @click="tipoConsultaFocusNFe = true"
                        v-if="movCompraData.status === 'AG' || movCompraData.status === 'AT' || movCompraData.status == 'NG'">
                <i class="bx bx-search-alt font-size-16 align-middle me-2"></i>
                Consultar status da NF-e
              </b-button> -->

              <b-dropdown
                  ngbDropdown
                  menu-class="dropdown-menu-md dropdown-menu-end mx-2"
                  right
                  variant="light"
                  v-if="movCompraData.status === 'AT'"
              >
                <template v-slot:button-content>
                  <i class="bx bx-download me-1"></i>
                  <span class="d-none d-sm-inline-block" ngbDropdownToggle>
                      Baixar
                      <i class="mdi mdi-chevron-down"></i>
                    </span>
                </template>


                <div v-if="!loadingPedido">


                  <a class="dropdown-item text-primary text-center"
                     @click="downloadXmlFocusnfe"
                     href="javascript: void(0);">
                    XML
                  </a>
                  <b-dropdown-divider></b-dropdown-divider>
                  <a class="dropdown-item text-primary text-center"
                     @click="downloadDanfeFocusnfe"
                     href="javascript: void(0);">
                    PDF Danfe
                  </a>

                </div>

              </b-dropdown>

              <b-button variant="outline-danger" class="mx-2" @click="showModalCancFocusNfe = true"
                        v-if="movCompraData.status === 'AT'">
                <i class="bx bx-x font-size-16 align-middle me-2"></i>
                Cancelar NFe
              </b-button>

              <b-button variant="outline-primary" class="mx-2" @click="showModalCorrFocusNfe = true"
                        v-if="movCompraData.status === 'AT'">
                <i class="bx bx-edit font-size-16 align-middle me-2"></i>
                Enviar carta de correção
              </b-button>

              <b-button
                  variant="outline-success"
                  class="mx-2"
                  @click="gerarFinanceiro">
                <i class="bx bx-money font-size-16 align-middle me-2"></i>
                Gerar Financeiro
              </b-button>

              <b-button variant="outline-primary" class="mx-2" @click="salvar" :disabled="movCompraData.status !== 'EL'"
                        v-if="movCompraData.status === 'EL'">
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar Alterações
              </b-button>

              <b-button variant="outline-info" class="mx-2" @click="downloadXmlFocusnfe"
                        v-if="movCompraData.status === 'AT'">
                <i class="bx bx-cloud-download font-size-16 align-middle me-2"></i>
                Baixar NF-e
              </b-button>

              <b-button variant="outline-info" class="mx-2" @click="abrirFinanceiro"
                        v-if="financeiroData && financeiroData.id > 0">
                <i class="bx bx-money font-size-16 align-middle me-2"></i>
                Financeiro
              </b-button>

              <!-- BOTÕES ANTERIORES ROGÉRIO
              <b-button variant="outline-success" class="mx-2" @click="visualizarXML">
                <i class="bx bx-search font-size-16 align-middle me-2"></i>
                Visualizar XML
              </b-button>-->

              <!--              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="integrCorpem">-->
              <!--                <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>-->
              <!--                Integração Corpem-->
              <!--              </b-button>-->

              <!--              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="copiar">-->
              <!--                <i class="bx bx-copy font-size-16 align-middle me-2" ></i>-->
              <!--                Copiar-->
              <!--              </b-button>-->

              <!--              <b-button variant="outline-danger" class="mx-2" @click="cancelar" :disabled="movCompraData.status !== 'EL'" v-if="movCompraData.status === 'EL'">-->
              <!--                <i class="bx bxs-trash font-size-16 align-middle me-2"></i>-->
              <!--                Cancelar-->
              <!--              </b-button>-->

              <b-button variant="outline-warning" class="mx-2" @click="novoProduto"
                        :disabled="movCompraData.status !== 'EL'" v-if="movCompraData.status === 'EL'">
                <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
                Novo Produto
              </b-button>


              <b-button variant="outline-info"
                        class="mx-2"
                        @click="gerarSaldo"
                        v-if="userLogged && userLogged.email === 'admin@admin.com.br'">
                <i class="bx bx-download font-size-16 align-middle me-2"></i>
                Gerar Saldo (APENAS ADMIN)
              </b-button>

              <b-button variant="outline-info"
                        class="mx-2"
                        @click="gerarFinanc"
                        v-if="userLogged">
                <i class="bx bx-download font-size-16 align-middle me-2"></i>
                Gerar Financ (APENAS ADMIN)
              </b-button>

              <b-button
                  variant="outline-info"
                  class="mx-2"
                  @click="gerarWmsOs"
                  v-if="userLogged && userLogged.email === 'admin@admin.com.br'">
                <i class="bx bx-download font-size-16 align-middle me-2"></i>
                Gerar OS (APENAS ADMIN)
              </b-button>


              <!--              <b-button variant="outline-warning" class="mx-2" @click="novoAnexo" :disabled="movCompraData.id === 0">-->
              <!--                <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>-->
              <!--                Novo Anexo-->
              <!--              </b-button>-->


              <b-dropdown
                  ngbDropdown
                  menu-class="dropdown-menu-md dropdown-menu-end mx-2"
                  right
                  variant="light">
                <template v-slot:button-content>
                  <i class="mdi mdi-attachment me-1"></i>
                  <span class="d-none d-sm-inline-block" ngbDropdownToggle>
                      Auxiliar
                      <i class="mdi mdi-chevron-down"></i>
                    </span>
                </template>


                <div v-if="!updating">

                  <a class="dropdown-item text-primary text-center"
                     @click="copiar"
                     href="javascript: void(0);">
                    Copiar Movimento
                  </a>
                  <b-dropdown-divider></b-dropdown-divider>

                  <a class="dropdown-item text-primary text-center"
                     @click="cancelar"
                     href="javascript: void(0);">
                    Cancelar
                  </a>
                  <b-dropdown-divider></b-dropdown-divider>

                  <a class="dropdown-item text-primary text-center"
                     @click="novoAnexo"
                     href="javascript: void(0);">
                    Novo Anexo
                  </a>
                  <b-dropdown-divider></b-dropdown-divider>
                  <a class="dropdown-item text-primary text-center"
                     @click="showModalAnexoList = true"
                     href="javascript: void(0);">
                    Visualizar Anexos
                  </a>

                </div>

              </b-dropdown>


              <!--                    <span-->
              <!--                        class="avatar-title rounded-circle bg-soft bg-warning text-warning font-size-22"-->
              <!--                    >-->
              <!--                      <i class="mdi mdi-cash"></i>-->
              <!--                    </span>-->
              <div class="flex-grow-1 align-self-center">
                <div class="text-muted">
                  <!--                  <h5>R$ 4.855.745,00 (recebíveis hoje)</h5>-->
                  <!--                  <p class="mb-1">R$ 978.444,00 a pagar hoje</p>-->
                  <!--                  <p class="mb-0">Id no: #SK0234</p>-->
                </div>
              </div>

              <button
                  class="btn btn-success"
                  @click="confirmar"
                  :disabled="movCompraData.status !== 'EL'"
                  v-if="movCompraData.status === 'EL' && movCompraItensData && movCompraItensData.length > 0">
                <i class="mdi mdi-check-circle me-1 text-end"></i> CONFIRMAR
              </button>

            </div>
          </div>
        </div>
      </div>

      <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`" show dismissible variant="danger">
        <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
        favor ajustar e tentar novamente.
      </b-alert>

      <div class="col-xl-4">

        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <div class="me-3">
                <!--                <img-->
                <!--                    src="@/assets/images/users/avatar-2.jpg"-->
                <!--                    alt=""-->
                <!--                    class="avatar-sm rounded-circle img-thumbnail"-->
                <!--                />-->
                <span
                    v-if="fornecedorData"
                    class="avatar-title rounded-circle"
                    style="max-height: 55px;
                    min-width: 55px;">{{ fornecedorData.codigo }}
                </span>
              </div>
              <div class="flex-grow-1">
                <div class="d-flex">
                  <div class="flex-grow-1">
                    <div class="text-muted">

                      <a href="javascript: void(0);" v-if="!fornecedorData" @click="selecionaCli">
                        <h5 class="mb-1 text-info">Selecionar fornecedor ...</h5>
                      </a>

                      <a href="javascript: void(0);" v-if="fornecedorData" @click="selecionaCli">
                        <h5 class="mb-1">{{ fornecedorData.codigo }} - {{ fornecedorData.nome }}</h5>
                        <p class="mb-0">{{ fornecedorData.cidade }}, {{ fornecedorData.estado }}</p>
                      </a>

                    </div>
                  </div>

                  <router-link :to="`/cliente/detalhe/${fornecedorData.id}`" class="ms-2" v-if="fornecedorData"
                               target="_blank">
                    Detalhes Fornecedor
                    <i class="mdi mdi-arrow-right ms-1"></i>
                  </router-link>

                </div>
                <hr/>
                <div class="row">

                  <div class="col-3">
                    <div>
                      <p class="text-muted text-truncate mb-2">Valor Total</p>
                      <h6 class="mb-0">R$ {{ movCompraData.valorliq ?? formatDecimal(movCompraData.valorliq) }}</h6>
                    </div>
                  </div>


                  <div class="col-3">
                    <div>
                      <p class="text-muted text-truncate mb-2">Peso Total</p>
                      <h6 class="mb-0">{{ movCompraData.peso ?? formatDecimal(movCompraData.peso) }} kg</h6>
                    </div>
                  </div>


                  <div class="col-3">
                    <div>
                      <p class="text-muted text-truncate mb-2">Número</p>
                      <h6 class="mb-0">{{ movCompraData.codigo }}</h6>
                    </div>
                  </div>

                  <div class="col-3">
                    <!--                    <div>-->
                    <!--                      <p class="text-muted text-truncate mb-2">Data</p>-->
                    <!--                      <h5 class="mb-0">{{ formatDate(movCompraData.dtemissao) }} </h5>-->
                    <!--                    </div>-->

                    <div class="">

                      <a href="javascript: void(0);" @click="showModalEmissao = true">
                        <p class="text-muted text-truncate mb-2">Data</p>
                        <h6 class="mb-0">{{ movCompraData.dtemissao_fmt }} </h6>
                      </a>

                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div class="card">
          <div class="card-body">
            <div class="d-flex flex-wrap">

              <a href="javascript: void(0);" v-if="!naturezaData" @click="selecionaPedTipo">
                <h5 class="card-title mb-3 me-2">{{ movCompraData.tipo }}</h5>
              </a>

              <a href="javascript: void(0);" v-if="naturezaData" @click="selecionaPedTipo">
                <h5 class="card-title mb-3 me-2">{{ naturezaData != null ? naturezaData.descricao : '' }}</h5>
              </a>

              <b-dropdown
                  toggle-class="text-muted font-size-16 p-0"
                  variant="white"
                  right
                  class="ms-auto"
                  menu-class="dropdown-menu-end"
              >
                <template #button-content>
                  <i class="mdi mdi-dots-horizontal"></i>
                </template>
<!--                <b-dropdown-item href="#" @click="selecionaCondPgto">Alterar Condição</b-dropdown-item>-->
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item href="#">Nova Chave de Desconto</b-dropdown-item>
              </b-dropdown>
            </div>

            <div class="d-flex flex-wrap">
              <div>
<!--

                <a href="javascript: void(0);" v-if="!formaPgtoData" @click="selecionaFormaPgto">
                  <p class="text-muted mb-1">{{ movCompraData.formapgto }}</p>
                </a>
                <a href="javascript: void(0);" v-if="formaPgtoData" @click="selecionaFormaPgto">
                  <p class="text-muted mb-1">{{ formaPgtoData != null ? formaPgtoData.descricao : '' }}</p>
                </a>

                <a href="javascript: void(0);" v-if="condPgtoData" @click="selecionaCondPgto">
                  <h4 class="mb-3">{{ condPgtoData != null ? condPgtoData.descricao : '' }}</h4>
                </a>
-->

                <a href="javascript: void(0);" @click="showModalFinConta = true">
                  <p class="text-success mb-0">
                      <span>{{ movCompraData.finconta !== null ? movCompraData.finconta : 'Conta Financ.' }} <i
                          class="mdi mdi-arrow-right ms-1"></i
                      ></span>
                  </p>
                </a>

              </div>

              <div class="ms-auto align-self-end">
                <i class="bx bx-detail display-4 text-light"></i>
              </div>
            </div>

            <hr/>

            <div class="d-flex flex-wrap">
              <div>

                <a href="javascript: void(0);" @click="alteraObs">
                  <p class="text-warning mb-0">
                      <span>
                        {{ movCompraData.obs != null ? movCompraData.obs : 'Observações' }}
                        <i class="mdi mdi-chat-alert ms-1"></i>
                      </span>
                  </p>
                </a>

              </div>

            </div>

          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <div class="row">
              <!--natureza da operação-->
              <div class="row mb-2">
                <div class="d-flex">
                  <h5>Natureza da operação:</h5>
                  <i @click="redirecionarNatureza" class="bx bx-link-external font-size-16 align-middle me-3" style="cursor:pointer;" title="Acessar Naturezas"></i>
                  <h6 class="text-muted ms-auto"
                      style="cursor:pointer;"
                      @click="editarNatureza">
                    <i class="bx bx-pencil font-size-12 align-middle mx-1"/>
                    Editar Dados Financeiros
                  </h6>
                </div>

                <div class="mt-1 align-items-baseline">
                  <div class="mt-2 d-flex">
                    <h6 class="">CFOP:
                      <span class="text-muted ms-2">{{ naturezaData?.cfopicms ?? 'Sem CFOP'}}</span>
                    </h6>
                  </div>

                  <div class="d-flex">
                    <h6 class="">Descrição:
                      <span class="text-muted ms-2">{{ naturezaData?.descricao ?? '-' }}</span>
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="d-flex">
                <h4>Dados Financeiros:</h4>
                <h6 class="text-muted ms-auto"
                    style="cursor:pointer;"
                    @click="editarFinanceiro">
                  <i class="bx bx-pencil font-size-12 align-middle mx-1"/>
                  Editar Dados Financeiros
                </h6>
              </div>

              <div class="row">

                <div class="d-flex col-sm-6 mt-2">
                  <h6 class="">Forma Pgto:
                    <span class="text-muted ms-2" style="">{{ movCompraData?.formapgto}}</span>
                    <span class="text-muted ms-1" v-if="formaPgtoData"> ( {{ formaPgtoData?.descricao }} )</span>
                  </h6>
                </div>

                <div class="d-flex col-sm-6 mt-2">
                  <h6 class="">Banco:
                    <span class="text-muted ms-2" style="">{{ movCompraData?.banco_id}}</span>
                    <span class="text-muted ms-1" v-if="contaData">
                        ( {{ contaData?.banco}} - {{ contaData?.descricao}} )
                      </span>
                  </h6>
                </div>

                <div class="d-flex col-sm-6">
                  <h6 class="">Cond. Pgto:
                    <span class="text-muted ms-2">{{ movCompraData?.condpgto }}</span>
                    <span class="text-muted ms-1" v-if="condPgtoData"> ( {{ condPgtoData?.descricao }} )</span>
                  </h6>
                </div>

                <div class="d-flex col-sm-6">
                  <h6 class="">Cons. dia útil::
                    <span class="text-muted ms-2" style="">{{ movCompraData?.consutil}}</span>
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Associação Nota Fiscal + Código Compra</h4>
            <div class="row">
              <div class="col-4">
                <label for="cnfmovcompra" class="text-muted text-truncate mb-2">
                  Associar NF-e
                  <i v-if="movCompraData.status === 'EL'" style="cursor:pointer" class="mdi mdi-refresh-circle font-size-18"
                     @click="alterarSelecaoNotaMovCompra"
                     title="Alterar forma indicação de nota fiscal"></i>
                </label>
                <!--caso associação NÃO esteja atrlada à uma movcompra-->
                <div v-if="tipoAssociacaoNota === 'custom'">
                  <input
                      @change="salvar"
                      id="customcodmovcompra"
                      type="text"
                      v-model="movCompraData.cnf"
                      placeholder="Número nota"
                      class="form-control"/>
                </div>

                <!--caso associação esteja atrlada à uma movcompra-->
                <div v-else>
                  <multiselect id="cnfmovcompra"
                               @search-change="pesqMovimento"
                               @select="associouMovimento"
                               v-model="movCompraData.cnf"
                               placeholder="Selecionar MovCompra"
                               :options="optionList"
                               :searchable="true"
                               label="codigo"
                               track-by="codigo"
                               value-prop="codigo">
                    <template v-if="!optionList" #option="slotProps">
                      <div class="row">
                        <div class="mt-2 font-size-20">{{ `Cód:${slotProps.option.codigo}` }}</div>
                      </div>
                    </template>
                  </multiselect>
                </div>
              </div>

              <div class="col-4">
                <div>
                  <label for="codmovcompra" class="text-muted text-truncate mb-2">
                    Código compra
                    <i v-if="movCompraData.status === 'EL' && movCompraData.codigo !== null" variant="outline-danger" style="cursor:pointer" class="bx bx-x font-size-20 align-middle me-2 text-danger mt-1"
                    @click="removerCodMovCompra"
                    title="Remover NF-e Associada"></i>
                  </label>

                  <input
                    @change="salvar"
                    id="codmovcompra"
                    type="text"
                    v-model="movCompraData.codigo"
                    class="form-control"/>
                </div>
              </div>
              <br>
            </div>

            <div class="row"  v-if="movimentoSelected && movimentoSelected.codigo">
              <h5 class="mt-3">Nota fiscal Associada
                <i v-if="movCompraData.status === 'EL' && movCompraData.cnf !== null" variant="outline-danger" style="cursor:pointer" class="bx bx-x font-size-20 align-middle me-2 text-danger mt-1"
                  @click="removerNotaAssoc"
                  title="Remover NF-e Associada"></i>
              </h5>
              <div class="table-responsive mt-2">
                <table class="table mb-0">
                  <tbody>
                  <tr>
                    <td>Chave NF-e:</td>
                    <td class="float-end"> {{ movimentoSelected.chave }}</td>
                  </tr>

                  <tr>
                    <td>Número NF-e:</td>
                    <td class="float-end"> {{ movimentoSelected.codigo }}</td>
                  </tr>

                  <tr>
                    <td>Emissor:</td>
                    <td class="float-end"> {{ movimentoSelected.remetnome }}</td>
                  </tr>

                  <tr>
                    <td>Destinatário:</td>
                    <td class="float-end"> {{ movimentoSelected.destnome }}</td>
                  </tr>

                  <tr>
                    <td>Data NF-e:</td>
                    <td class="float-end"> {{ formatDate(movimentoSelected.dtemissao) }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>


        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-3">Detalhamento de Valores</h4>

            <div class="table-responsive">
              <table class="table mb-0">
                <tbody>
                <tr>
                  <td>Valor Total Produtos</td>
                  <td class="float-end">{{ formatDecimal(movCompraData.valorbrt) }}</td>
                </tr>

                <tr>
                  <td>Valor Desconto</td>
                  <!--                  <td class="float-end"> {{ formatDecimal(movCompraData.desconto) }}</td>-->
                  <td class="float-end">

                    <a href="javascript: void(0);"
                       v-b-tooltip.hover
                       placement="top"
                       title="Alterar valor do desconto"
                       @click="showModalDesconto = true">
                      <p class="mb-0">
                      <span>
                        R$ {{ movCompraData.desconto != null ? formatDecimal(movCompraData.desconto) : '0,00' }}
                      </span>
                      </p>
                    </a>

                  </td>


                </tr>

                <tr>
                  <td>Base ICMS</td>
                  <td class="float-end"> {{ formatDecimal(movCompraData.baseicms) }}</td>
                </tr>

                <tr>
                  <td>Valor ICMS</td>
                  <td class="float-end"> {{ formatDecimal(movCompraData.valoricms) }}</td>
                </tr>

                <tr>
                  <td>Valor IPI</td>
                  <td class="float-end"> {{ formatDecimal(movCompraData.valoripi) }}</td>
                </tr>

                <tr>
                  <td>Valor Base ICMSST</td>
                  <td class="float-end"> {{ formatDecimal(movCompraData.baseicmsst) }}</td>
                </tr>

                <tr>
                  <td>Valor ICMSST</td>
                  <td class="float-end"> {{ formatDecimal(movCompraData.valoricmsst) }}</td>
                </tr>


                <tr>


                  <td>Frete ({{ movCompraData.frete }})</td>
                  <td class="float-end">

                    <a href="javascript: void(0);"
                       v-b-tooltip.hover
                       placement="top"
                       title="Alterar valor do frete"
                       @click="alteraFrete">
                      <p class="mb-0">
                      <span>
                        R$ {{ movCompraData.valorfrt != null ? formatDecimal(movCompraData.valorfrt) : '0,00' }}
                      </span>
                      </p>
                    </a>

                  </td>
                </tr>

                <tr>
                  <th>Valor Total Líquido</th>
                  <th class="float-end">{{ formatDecimal(movCompraData.valorliq) }}</th>
                </tr>

                </tbody>
              </table>
            </div>
            <!-- end table-responsive -->
          </div>
        </div>
        <!-- end card -->
      </div>

      <div class="col-xl-8">
        <div class="card">
          <div class="card-body">

            <div class="row mb-2">

              <!-- <div class="col-sm-2">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative">
                    <input
                        id="inputPesquisa"
                        type="text"
                        v-model="pesqTextFilter"
                        class="form-control"
                        style="min-width: 200px;"
                        placeholder="Enter para pesquisar..."
                        @change="carregarDadosItens"/>
                    <i class="bx bx-search-alt search-icon"></i>
                  </div>
                </div>
              </div> -->

            </div>

            <div class="table-responsive">
              <!-- <table class="table align-middle mb-0 table-nowrap">
                <thead class="table-light">
                <tr>
                  <th>Produtos ({{ movCompraItensData.length != null ? movCompraItensData.length : 0 }})</th>
                  <th>Descrição</th>
                  <th class="text-end">Valor Unit.(R$)</th>
                  <th class="text-end">Quantidade</th>
                  <th class="text-end">Desconto Unitário(R$)</th>
                  <th class="text-end">V.Total Líquido(R$)</th>
                  <th class="text-end">Ações</th>
                </tr>
                </thead>
                <tbody>

                <tr v-for="data in movCompraItensData" :key="data.id">

                  <td>
                    <h5 class="text-muted mb-0">{{ data.produto }} </h5>

                  </td>

                  <td>
                    <h5 class="font-size-14 text-truncate">
                      <a href="javascript: void(0);" class="text-body fw-bold  text-wrap"
                         @click="editarProduto(data.id)">
                        {{ \.descprod }}
                      </a>
                    </h5>
                    <p class="mb-0">

                      <span class="fw-medium"> {{ data.lote }} </span>
                    </p>
                  </td>

                  <td class="text-end">{{ formatDecimal(data.vlrunitbrt) }}</td>
                  <td class="text-end">{{ formatDecimal(data.qtd) }}</td>

                  <td class="text-end">
                    <span class="badge badge-pill badge-soft-success font-size-11"
                          :class="data.desconto <= 0.00 ? 'badge-soft-success' :
                          data.desconto > 0 ? 'badge-soft-danger' :  ''">
                      {{ formatDecimal(data.desconto) }}
                    </span>
                  </td>

                  <td class="text-end">{{ formatDecimal(data.vlrtotalliq) }}</td>

                  <td class="text-end">

                    <a href="javascript:void(0);"
                       v-if="movCompraData.status === 'EL'"
                       class="action-icon text-warning mx-2"
                       @click="editarProduto(data.id)">
                      <i class="mdi mdi-pencil-outline font-size-18"></i>
                    </a>

                    <a href="javascript:void(0);"
                       v-if="movCompraData.status === 'EL'"
                       class="action-icon text-danger mx-2"
                       @click="deletarMovCompraItem(data.id)">
                      <i class="mdi mdi-trash-can font-size-18"></i>
                    </a>

                  </td>

                </tr>


                </tbody>
              </table> -->

              <Loader v-if="updating" style="min-height: 300px"> </Loader>

              <div class="mt-2" v-if="!updating">
                <DxDataGrid
                  ref="dataGridRefKey"
                  :data-source="movCompraItensData"
                  :show-borders="true"
                  :focused-row-enabled="true"
                  :keyExpr="'id'"
                  :column-auto-width="true"
                  :show-row-lines="true"
                  :allow-column-reordering="true"
                  :allow-column-resizing="true"
                  :row-alternation-enabled="true"
                  @cell-prepared="onCellPrepared"
                  @row-dbl-click="onRowDblClick"
                  @content-ready="carregouGrid"
                  @exporting="onExporting"
                >
                  <DxRemoteOperations
                    :filtering="true"
                    :paging="true"
                    :sorting="true"
                    :summary="true"
                    :grouping="false"
                    :group-paging="false"
                  />

                  <DxColumnChooser :enabled="true" />
                  <DxColumnFixing :enabled="true" />
                  <DxFilterRow :visible="true" />

                  <DxSelection mode="multiple" />
                  <DxExport
                    :enabled="true"
                    :allow-export-selected-data="true"
                  />
                  <DxStateStoring
                    :enabled="true"
                    type="sessionStorage"
                    storage-key="strWmsOsEntradaList"
                  />

                  <DxGroupPanel :visible="true" />
                  <DxGrouping />

                  <DxColumn
                      data-field="produto"
                      :caption="`Produto (${movCompraItensData.length})` "
                      sort-order="asc"
                      data-type="text"
                      alignment="left"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="true"
                  />

                  <DxColumn
                    data-field="descprod"
                    caption="Descrição"
                    data-type="text"
                    alignment="left"
                    :filter-operations="[
                      'contains',
                      'notcontains',
                      'startswith',
                      'endswith',
                      '=',
                      '<>',
                    ]"
                    :allow-sorting="false"
                    :allowHeaderFiltering="true"
                  />

                  <DxColumn
                      data-field="lote"
                      caption="Lote"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                      data-field="qtd"
                      caption="Quantidade"
                      alignment="right"
                      :format="formatDecimal"
                      :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
                      :allowHeaderFiltering="false"
                  />

                  <DxColumn
                    data-field="vlrunitbrt"
                    caption="Valor Unit.(R$)"
                    data-type="text"
                    :format="formatDecimal"
                    alignment="center"
                    :filter-operations="[
                      'contains',
                      'notcontains',
                      'startswith',
                      'endswith',
                      '=',
                      '<>',
                    ]"
                    :allow-sorting="false"
                    :allowHeaderFiltering="true"
                  />

                  <DxColumn
                      data-field="desconto"
                      caption="Desconto Unitário(R$)"
                      :format="formatDecimal"
                      data-type="text"
                      alignment="left"
                      :customize-text="formatBoolean"
                      :filter-operations="[
                      'contains',
                      'notcontains',
                      'startswith',
                      'endswith',
                      '=',
                      '<>',
                    ]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="true"
                  />

                  <DxColumn
                      data-field="vlrtotalliq"
                      caption="V.Total Líquido(R$)"
                      :format="formatDecimal"
                      data-type="text"
                      alignment="center"
                      :filter-operations="[
                      'contains',
                      'notcontains',
                      'startswith',
                      'endswith',
                      '=',
                      '<>',
                    ]"
                      :allow-sorting="false"
                      :allowHeaderFiltering="true"
                  />

                  <DxPager
                    :visible="true"
                    :show-page-size-selector="true"
                    :allowed-page-sizes="[10, 30, 50, 100]"
                    :show-navigation-buttons="true"
                    :show-info="true"
                  />
                </DxDataGrid>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="!updating">
      <div class="col-xl-12">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0">

              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalItens"
                  @update:modelValue="onPageChange">
              </b-pagination>

            </ul>
          </div>
        </div>
      </div>
    </div>


    <b-modal :title="fornecedorData != null ? `Detalhes Fornecedor (${ fornecedorData.nome })` : 'Detalhes Fornecedor'"
             v-model="showModalFornecedor" centered hide-footer>

      <div class="col-md-12">
        <div class="mb-3">
          <label for="cidade">Fornecedor</label>

          <multiselect @search-change="pesqFornec"
                       @select="escolheuFor"
                       v-model="movCompraData.fornec"
                       placeholder="Pesquisar fornecedor"
                       :options="dtListPesqFor"
                       :searchable="true"
                       label="nome"
                       track-by="nome"
                       value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4">
                    {{ slotProps.option.cnpj }}
                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                <div class="align-items-end text-end align-content-end">{{ slotProps.option.cidade }} -
                  {{ slotProps.option.estado }}
                </div>
              </div>
            </template>
          </multiselect>

        </div>
      </div>


      <div class="row" v-if="loadingFornec">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingFornec && fornecedorData">
        <router-link :to="`/cliente/detalhe/${fornecedorData.id}`" target="_blank">
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ fornecedorData.codigo }} </span>
          </p>
        </router-link>
        <p class="mb-2">
          Endereço:
          <span> {{ fornecedorData.rua }}, {{ fornecedorData.numero }}, {{ fornecedorData.bairro }}  </span>
          <span> {{ fornecedorData.cidade }} - {{ fornecedorData.estado }} </span>
        </p>
        <p class="mb-4">
          <span> {{ fornecedorData.tel1 }} / {{ fornecedorData.email }}</span>
        </p>
        <div class="table-responsive">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Últimas Compras</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in ultPedsData" :key="data.id">
              <td>
                <router-link :to="`/movcompra/editar/${data.id}`" target="_blank">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      {{ data.codigo }}
                    </h5>
                  </div>
                </router-link>
              </td>
              <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Valor Total Pedidos:</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(somaPedidosFor) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(somaPedidosFor / 3) }}</td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>

      <div>
        <div class="text-start mt-5">
          <router-link to="/cliente/editar/0" target="_blank">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            Cadastrar Novo Fornecedor
          </router-link>
        </div>
      </div>

      <div v-if="!loadingFornec && fornecedorData">
        <div class="text-end mt-0">
          <b-button variant="light" @click="showModalFornecedor = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarFornec">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal title="Detalhes Tipo de operação" v-model="showModalPedTipo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Novo Tipo de Operação</label>

          <multiselect id="tipooperacao"
                       @search-change="pesqNatureza"
                       @click="escolheuNatureza"
                       v-model="movCompraData.tipo"
                       placeholder="Pesquisar tipo de operação"
                       :options="dtlistPesqNatureza"
                       :searchable="true"
                       label="descricao"
                       track-by="descricao"
                       value-prop="id">
                    <template #option="slotProps">
                      <div class="row">
                        <div>
                          <span class="text-muted font-size-14">
                            CFOP: {{ slotProps.option.cfopicms ?? 'Sem Cadastrado!' }}
                          </span>
                        </div>

                        <span class="mx-4"></span>

                        <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>

                        <span class="mx-4"></span>

                        <div class="align-items-end text-end align-content-end">
                          {{ formatDateTime(slotProps.option.created_at) }}
                        </div>
                      </div>
                    </template>
          </multiselect>

        </div>
      </div>

      <div class="row" v-if="loadingPedTipo">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>


      <div v-if="!loadingPedTipo && naturezaData">
        <p class="mb-2">
          Tipo de Operação Atual
        </p>
        <router-link :to="`/tiposopera/list`" target="_blank">
          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ naturezaData?.codigo ?? "-" }} </span>
          </p>

          <p class="mb-2">
            Descrição:
            <span class="text-primary"> {{ naturezaData?.descricao ?? "-" }}  </span>
          </p>
        </router-link>

        <div class="table-responsive" v-if="ultPedsData">
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Últimas Compras</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in ultPedsData" :key="data.id">
              <td>
                <router-link :to="`/movcompra/editar/${data.id}`" target="_blank">
                  <div>
                    <h5 class="text-truncate font-size-14">
                      {{ data.codigo }}
                    </h5>
                  </div>
                </router-link>
              </td>
              <td class="text-end">{{ formatDateTime(data.created_at) }}</td>
              <td class="text-end">{{ formatDecimal(data.valorliq) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 text-end">Valor Total Pedidos:</h6>
              </td>
              <td class="text-end">R$ {{ formatDecimal(somaPedidosFor) }}</td>
            </tr>
            <tr>
              <td colspan="2">
                <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>
              </td>
              <td class="font-size-14 text-end">R$ {{ formatDecimal(somaPedidosFor / 3) }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalPedTipo = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarPedTipo">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal title="Editar Dados Financeiros" v-model="showModalFinanceiroData" centered hide-footer>
      <div class="row mt-3">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="condpgto">Condição de Pagamento</label>
            <multiselect id="condpgto"
                         @search-change="pesqCondPgto"
                         @select="escolheuCondPgto"
                         v-model="movCompraData.condpgto"
                         placeholder="Pesquisar condição de pagamento"
                         :options="dtListPesqCondPgto"
                         :searchable="true"
                         label="descricao"
                         class="multiselect-size"
                         track-by="codigo"
                         value-prop="codigo">
              <template #option="slotProps">
                <div class="row">
                  <div>
                    <span class="text-info">
                      {{ slotProps.option.codigo }}
                    </span>
                    <span class="ms-2" >
                      {{ slotProps.option.descricao }}
                    </span>
                  </div>
                </div>
              </template>
            </multiselect>
          </div>
        </div>


        <div class="col-md-6">
          <div class="mb-3">
            <label for="formapgto">Forma de Pagamento</label>
            <multiselect id="formapgto"
                         @search-change="pesqFormaPgto"
                         @select="escolheuFormaPgto"
                         v-model="movCompraData.formapgto"
                         placeholder="Pesquisar forma de pagamento"
                         :options="dtListPesqFormaPgto"
                         :searchable="true"
                         label="descricao"
                         class="multiselect-size"
                         track-by="codigo"
                         value-prop="codigo">
              <template #option="slotProps">
                <div class="row">
                  <div>
                    <span class="text-info">
                      {{ slotProps.option.codigo }}
                    </span>
                    <span class="ms-2" >
                      {{ slotProps.option.descricao }}
                    </span>
                  </div>
                </div>
              </template>
            </multiselect>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="banco">Instituição bancária</label>
            <multiselect id="inputFinConta"
                         @search-change="pesqConta"
                         @select="escolheuConta"
                         v-model="movCompraData.banco_id"
                         placeholder="Selecione a Inst. Bancária"
                         :options="dtListPesqConta"
                         :searchable="true"
                         label="descricao"
                         class="multiselect-size"
                         track-by="id"
                         value-prop="id">
              <template #option="slotProps">
                <div class="row">
                  <div>
                    <span class="text-info">
                      {{ slotProps.option.id }}
                    </span>
                    <span class="font-size-10 mx-1 me-4">
                       (banco: {{ slotProps.option.banco }})
                    </span>
                    <span class="" >
                      {{ slotProps.option.descricao }}
                    </span>
                  </div>
                </div>
              </template>
            </multiselect>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <div class="mb-4 align-items-end align-content-start float-start mx-4">
              <label for="consutil">Considerar apenas dias úteis</label>
              <b-form-checkbox switch size="lg" v-model="movCompraData.consutil">
                {{ movCompraData.consutil === false ? 'Desativado' : 'Ativado' }}
              </b-form-checkbox>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="loadingFinanc">
        <div class="col-12 text-center">
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
          <b-spinner type="grow" class="m-6 mx-2" variant="secondary" role="status">
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingFinanc && movCompraData">
        <div class="row mt-2">
          <h6 class="mb-2 col-md-12">Condição de Pagamento Atual:</h6>

          <div class="row">

            <div class="d-flex col-sm-6 mt-2">
              <h6 class="">Forma Pgto:
                <span class="text-muted ms-2" style="">{{ movCompraData?.formapgto}}</span>
                <span class="text-muted ms-1" v-if="formaPgtoData"> ( {{ formaPgtoData?.descricao }} )</span>
              </h6>
            </div>

            <div class="d-flex col-sm-6 mt-2">
              <h6 class="">Banco:
                <span class="text-muted ms-2" style="">{{ movCompraData?.banco_id}}</span>
                <span class="text-muted ms-1" v-if="contaData">
                        ( {{ contaData?.banco}} - {{ contaData?.descricao}} )
                      </span>
              </h6>
            </div>

            <div class="d-flex col-sm-6">
              <h6 class="">Cond. Pgto:
                <span class="text-muted ms-2">{{ movCompraData?.condpgto }}</span>
                <span class="text-muted ms-1" v-if="condPgtoData"> ( {{ condPgtoData?.descricao }} )</span>
              </h6>
            </div>

            <div class="d-flex col-sm-6">
              <h6 class="">Cons. dia útil::
                <span class="text-muted ms-2" style="">{{ movCompraData?.consutil}}</span>
              </h6>
            </div>
          </div>

        </div>




        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalFinanceiroData = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarFinanceiro">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>
    </b-modal>


    <b-modal title="Alterar Observação" v-model="showModalObs" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="observacao">Favor informar as observações</label>
          <textarea
              id="obs"
              v-model="movCompraData.obs"
              type="text"
              rows="3"
              class="form-control"
              placeholder="Observações"/>
        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalObs = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="showModalObs = false">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>

    <b-modal size="lg"
             :title="movCompraItemData.id != null ? `Editar Item da Compra (${ movCompraItemData.id })` : 'Criar Novo Item na Compra'"
             v-model="showModalMovCompraItem"
             hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="cidade">Selecionar Novo Produto</label>
          <multiselect @search-change="pesqMovCompraItem"
                       @select="escolheuMovCompraItem"
                       v-model="movCompraItemData.produto"
                       placeholder="Pesquisar novo produto"
                       :options="dtlistPesqMovCompraItem"
                       :searchable="true"
                       label="descricao"
                       class="multiselect-size"
                       track-by="descricao"
                       value-prop="codigo">
            <template #option="slotProps" v-if="dtlistPesqMovCompraItem">
              <div class="row" style="min-width: 100%;">

                <div style="min-width: 100%;">
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4">
                    {{ slotProps.option.unidade }}
                  </span>
                  <span class="float-end text-warning">
                    R$ {{ formatDecimal(slotProps.option.preco) }}
                  </span>
                </div>

                <div class="col-12">
                  <span class="mt-5 font-size-15">
                    {{ slotProps.option.descricao }}
                  </span>
                  <span class="float-end">

                  </span>
                </div>

                <div class="align-items-end text-end align-content-end float-end">
                  <div class="avatar-xs">
                    <span class="avatar-title rounded-circle">{{ slotProps.option.id }}</span>
                  </div>


                  <span class="float-end ">
                    <span v-if="slotProps.option.saldo > 0"
                          class="avatar-title rounded-circle bg-success avatar-xs p-1">
                      <span class="">{{ formatInteger(slotProps.option.saldo) }}</span>
                    </span>

                    <span v-else class="avatar-title rounded-circle bg-danger avatar-xs p-1">
                      <span class="">{{ formatInteger(slotProps.option.saldo) }}</span>
                    </span>

                  </span>
                </div>


              </div>
            </template>
          </multiselect>
        </div>
      </div>
      <div class="row" v-if="loadingMovCompraItem">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>

      <div v-if="!loadingMovCompraItem && movCompraItemData && movCompraItemData.descprod">

        <router-link :to="`/produto/editar/${movCompraItemData.produto_id}`" target="_blank">
          <div class="row">

            <div class="col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body" style="min-height: 160px;">
                  <div class="d-flex flex-wrap">
                    <div class="me-2">
                      <p class="text-muted mb-2">{{ movCompraItemData.descprod }}</p>
                      <h5 class="mb-0">saldo: ({{ formatDecimal(movCompraItemData.saldo) }})</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-sm ms-auto" v-if="!movCompraItemData.img1">
                        <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                          <i class="bx bx-camera-off"></i>
                        </div>
                      </div>

                      <div class="avatar-sm ms-auto" v-if="movCompraItemData.img1">
                        <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                          <img class="rounded-circle avatar-xs" :src="movCompraItemData.img1" alt/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="card mini-stats-wid">
                <div class="card-body" style="min-height: 174px;">
                  <div class="d-flex flex-wrap">
                    <div class="me-2">
                      <span class="text-muted mb-2">Código: </span> <span
                        class="text-info">   {{ movCompraItemData.produto }} </span>
                    </div>
                    <div class="">
                      <p class="text-muted mb-2">Preço de Tabela (Bruto)</p>
                      <h5 class="mb-0 mt-3">R$ {{ formatDecimal(movCompraItemData.vlrunitbrt) }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                        <i class="bx bx-money"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </router-link>

        <form class="needs-validation" @submit.prevent="confMovCompraItem">

          <div class="row">

            <div class="col-md-4">
              <div class="mb-3">
                <label for="lote">Lote</label>
                <input
                    id="lote"
                    v-model="movCompraItemData.lote"
                    type="text"
                    class="form-control"
                    placeholder="Lote de fabricação"/>
              </div>
            </div>

            <div class="col-md-4">
              <div class="mb-3">
                <label for="dtfabric">Data de fabricação</label>
                <input
                    id="dtfabric"
                    v-model="movCompraItemData.dtfabric"
                    type="date"
                    class="form-control"
                    placeholder="Data de fabricação"/>
              </div>
            </div>

            <div class="col-md-4">
              <div class="mb-3">
                <label for="dtvalid">Data de validade</label>
                <input
                    id="dtvalid"
                    v-model="movCompraItemData.dtvalid"
                    type="date"
                    class="form-control"
                    placeholder="Data de validade"/>
              </div>
            </div>

          </div>

          <div class="row">

            <div class="col-md-3">
              <div class="mb-3">
                <label for="serie">Série</label>
                <input
                    id="serie"
                    v-model="movCompraItemData.serie"
                    type="text"
                    class="form-control"
                    placeholder="Série"/>
              </div>
            </div>

            <div class="col-md-3">
              <div class="mb-3">
                <label for="vlrunitliq">Valor Unitário</label>
                <input
                    id="vlrunitliq"
                    v-model="movCompraItemData.vlrunitliq"
                    type="number"
                    class="form-control text-end"
                    placeholder="Valor unitário líquido"
                    :class="{'is-invalid': submitMovCompraItem && v$.movCompraItemData.vlrunitliq.$error,}"/>
                <div v-if="submitMovCompraItem && v$.movCompraItemData.vlrunitliq.$error"
                     class="invalid-feedback">
                  <span v-if="v$.movCompraItemData.vlrunitliq.required.$message">{{
                      v$.movCompraItemData.vlrunitliq.required.$message
                    }}</span>
                </div>
              </div>
            </div>


            <div class="col-md-2">
              <div class="mb-3">
                <label for="qtd">Quantidade</label>
                <input
                    id="qtd"
                    v-model="movCompraItemData.qtd"
                    type="number"
                    class="form-control text-end"
                    placeholder="Quantidade"
                    :class="{'is-invalid': submitMovCompraItem && v$.movCompraItemData.qtd.$error,}"/>
                <div v-if="submitMovCompraItem && v$.movCompraItemData.qtd.$error"
                     class="invalid-feedback">
                  <span v-if="v$.movCompraItemData.qtd.required.$message">{{
                      v$.movCompraItemData.qtd.required.$message
                    }}</span>
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <div class="mb-3">
                <label for="desconto">Desconto</label>
                <input
                    id="desconto"
                    v-model="movCompraItemData.desconto"
                    type="number"
                    class="form-control"
                    placeholder="Desconto unitário"/>
              </div>
            </div>



            <!-- PABLO - DESATIVADO POR CONTA DAS INFORMAÇÕES FISCAIS ESTAREM NAS TABELAS E NÃO PARA SEREM INFORMADOS PELO CLIENTE -->
            <!-- <div class="row">

            <div class="col-md-3">
              <div class="mb-3">
                <label for="icmsvbc">Base ICMS(R$)</label>
                <input
                    id="icmsvbc"
                    v-model="movCompraItemData.icmsvbc"
                    type="number"
                    class="form-control text-end"
                    placeholder="Base ICMS(R$)"/>
              </div>
            </div>

            <div class="col-md-3">
              <div class="mb-3">
                <label for="icmsvlr">Valor ICMS(R$)</label>
                <input
                    id="icmsvlr"
                    v-model="movCompraItemData.icmsvlr"
                    type="number"
                    class="form-control text-end"
                    placeholder="Valor ICMS(R$)"/>
              </div>
            </div>

            <div class="col-md-3">
              <div class="mb-3">
                <label for="icmsaliq">Alíq. ICMS(%)</label>
                <input
                    id="icmsaliq"
                    v-model="movCompraItemData.icmsaliq"
                    type="number"
                    class="form-control text-end"
                    placeholder="Alíq. ICMS(%)"/>
              </div>
            </div>

            <div class="col-md-3">
              <div class="mb-3">
                <label for="ipivlr">Valor IPI (R$)</label>
                <input
                    id="ipivlr"
                    v-model="movCompraItemData.ipivlr"
                    type="number"
                    class="form-control text-end"
                    placeholder="Valor IPI (R$)"/>
              </div>
            </div>

            <div class="col-md-3">
              <div class="mb-3">
                <label for="ipialiq">Alíq. IPI(%)</label>
                <input
                    id="ipialiq"
                    v-model="movCompraItemData.ipialiq"
                    type="number"
                    class="form-control text-end"
                    placeholder="Alíq. IPI(%)"/>
              </div>
            </div>

            <div class="col-md-3">
              <div class="mb-3">
                <label for="ipivlr">Valor IPI(R$)</label>
                <input
                    id="ipivlr"
                    v-model="movCompraItemData.ipivlr"
                    type="number"
                    class="form-control text-end"
                    placeholder="Valor IPI(R$)"/>
              </div>
            </div>

            <div class="col-md-3">
              <div class="mb-3">
                <label for="baseicmsst">Base ICMSST</label>
                <input
                    id="baseicmsst"
                    v-model="movCompraItemData.icmsstbase"
                    type="number"
                    class="form-control text-end"
                    placeholder="Base ICMSST"/>
              </div>
            </div>

            <div class="col-md-3">
              <div class="mb-3">
                <label for="icmsstvalor">Valor ICMSST</label>
                <input
                    id="icmsstvalor"
                    v-model="movCompraItemData.icmsstvalor"
                    type="number"
                    class="form-control text-end"
                    placeholder="Valor ICMSST"/>
              </div>
            </div>

            <div class="col-md-2">
              <div class="mb-3">
                <label for="cofinscst">CST COFINS</label>
                <input
                    id="cofinscst"
                    v-model="movCompraItemData.cofinscst"
                    type="text"
                    class="form-control"
                    placeholder="CST COFINS"/>
              </div>
            </div>-->
          </div>
        </form>
      </div>

      <div>
        <div class="row">
          <div class="text-start mt-5">
            <router-link to="/produto/editar/0" target="_blank">
              <i class="bx bx-plus font-size-16 align-middle me-2"></i>
              Cadastrar Novo Produto
            </router-link>
          </div>
        </div>
      </div>

      <div v-if="!loadingMovCompraItem && movCompraItemData && movCompraItemData.descprod">
        <div class="row">
          <div class="text-end mt-0">
            <b-button variant="light" @click="showModalMovCompraItem = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>
            <b-button variant="success" class="ms-1" @click="confMovCompraItem">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>


    <b-modal title="Importar XML" v-model="showModalImpXML" centered hide-footer>
      <div class="col-md-12">
        <DropZone @drop.prevent="drop" @change="selectedFile"/>
        <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalImpXML = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarXML">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal size="lg"
             title="Visualizar XML"
             v-model="showModalXML"
             hide-footer>
      <div>
        <div class="row">
          <div class="content">
            <div>XML-content:
              <pre>{{ xmlContent }}</pre>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalXML = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Fechar
            </b-button>

            <b-button variant="success" class="ms-1" @click="copiarXML">
              <i class="bx bx-copy font-size-16 align-middle me-2"></i>
              Copiar XML
            </b-button>

          </div>
        </div>
      </div>
    </b-modal>


    <b-modal size="xl"
             title="Integração Corpem"
             v-model="showModalMediaJson"
             hide-footer>
      <div v-if="mediaJsonCorpem && mediaJsonCorpem.id">
        <div class="row">

          <div class="col-md-12">
            <label for="objenvio" class="col-form-label col-lg-2">
              Objeto Enviado
            </label>
            <div class="col-lg-12">
                  <textarea
                      id="objenvio"
                      class="form-control"
                      rows="10"
                      v-model="mediaJsonCorpem.objenvio"
                      :disabled="true"
                      placeholder="Objeto enviado"
                  ></textarea>
            </div>
          </div>

        </div>

        <div class="row">

          <div class="col-md-12">
            <label for="objretorno" class="col-form-label col-lg-2">
              Objeto de Retorno
            </label>
            <div class="col-lg-12">
                  <textarea
                      id="objretorno"
                      class="form-control"
                      rows="10"
                      v-model="mediaJsonCorpem.objretorno"
                      :disabled="true"
                      placeholder="Objeto de retorno"
                  ></textarea>
            </div>
          </div>

        </div>


        <div class="row">
          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalMediaJson = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Fechar
            </b-button>

            <b-button variant="success" class="ms-1" @click="copiarXML">
              <i class="bx bx-copy font-size-16 align-middle me-2"></i>
              Copiar XML
            </b-button>

          </div>
        </div>
      </div>
    </b-modal>


    <b-modal size="lg"
             title="Endereçamento de Item" v-model="showModalSepara" centered hide-footer>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="palete">Favor informar o palete</label>
            <input
                id="palete"
                ref="palete"
                v-model="movCompraItemSepData.palete"
                type="number"
                class="form-control"
                @keypress.enter="informouPalete"
                placeholder="Palete"/>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="endwms">Endereço</label>
            <input
                id="endwms"
                v-model="movCompraItemSepData.endwms"
                type="text"
                class="form-control"
                :disabled="true"
                placeholder="Endereço"/>
          </div>
        </div>

      </div>

      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="qtdsep">Favor informar a quantidade</label>
            <input
                id="qtdsep"
                v-model="movCompraItemSepData.qtd"
                type="number"
                ref="qtdsep"
                class="form-control"
                @keypress.enter="informouQtd"
                placeholder="Quantidade a separar"/>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="qtdsepdisp">Quantidade Disponível</label>
            <input
                id="qtdsepdisp"
                v-model="movCompraItemSepDataDisp"
                type="text"
                class="form-control"
                :disabled="true"
                placeholder="Quantidade Disponível"/>
          </div>
        </div>

      </div>


      <div class="row" v-if="loadingWmsEnder">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>


      <div class="table-responsive" v-if="movCompraItemSepDataList">
        <table class="table table-centered table-nowrap">
          <thead>
          <tr>

            <th scope="col">Separado (ID)</th>
            <th scope="col">Palete</th>
            <th scope="col">Endereço</th>
            <th scope="col">Lote</th>
            <th scope="col">Fabricação</th>
            <th scope="col">Validade</th>
            <th scope="col" class="text-end">Quantidade</th>
            <!--            <th scope="col" class="text-end">Data</th>-->

          </tr>
          </thead>
          <tbody>
          <tr v-for="data in movCompraItemSepDataList" :key="data.id">
            <td>
              <div>
                <h5 class="text-truncate font-size-14">
                  {{ data.id }}
                </h5>
              </div>
            </td>
            <td class="">{{ data.palete }}</td>
            <td class="">{{ data.endwms }}</td>
            <td class="">{{ data.lote }}</td>
            <td class="">{{ formatDate(data.dtfabric) }}</td>
            <td class="">{{ formatDate(data.dtvalid) }}</td>
            <td class="text-end">{{ formatDecimal(data.qtd) }}</td>
            <!--            <td class="text-end">{{ formatDateTime(data.created_at) }}</td>-->

          </tr>

          <!--          <tr>-->
          <!--            <td colspan="2">-->
          <!--              <h6 class="m-0 text-end">Valor Total Pedidos:</h6>-->
          <!--            </td>-->
          <!--            <td class="text-end">R$  formatDecimal(somaPedidosFor) }}</td>-->
          <!--          </tr>-->
          <!--          -->
          <!--          <tr>-->
          <!--            <td colspan="2">-->
          <!--              <h6 class="m-0 font-size-14  text-end">Ticket Médio:</h6>-->
          <!--            </td>-->
          <!--            <td class="font-size-14 text-end">R$  formatDecimal(somaPedidosFor / 3) }}</td>-->
          <!--          </tr>-->

          </tbody>
        </table>
      </div>


      <div v-if="!loadingWmsEnder">

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalSepara = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1"
                    :disabled="movCompraItemSepDataDisp === 0 || movCompraItemSepData.qtd === 0 || movCompraItemSepData.qtd > movCompraItemSepDataDisp || !movCompraItemSepData.palete"
                    @click="confirmarSeparacao">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>


    </b-modal>


    <b-modal title="Criar Novo Anexo" v-model="showModalAnexo" centered hide-footer>
      <div>

        <div class="card-body">
          <h4 class="card-title">Selecionar novo arquivo</h4>
          <DropZone @change="selectedFile"/>
          <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>
          <div v-if="submittedAnexo && !dropzoneFile.name">
            <span class="text-danger font-size-11">Favor selecionar o arquivo e tentar novamente.</span>
          </div>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <label for="descranexo">Descrição</label>
              <div class="position-relative">
                <input
                    id="descranexo"
                    type="text"
                    v-model="descranexo"
                    class="form-control"
                    placeholder="Descrição do anexo"
                    :class="{'is-invalid': submittedAnexo && !descranexo}"/>
                <div v-if="submittedAnexo && !descranexo" class="invalid-feedback">
                  <span>Campo descrição obrigatório, favor preencher.</span>
                </div>

              </div>
            </div>
          </div>
        </div>


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalAnexo = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confAnexo">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal size="lg"
             title="Visualizar Anexos" v-model="showModalAnexoList" centered hide-footer>

      <div>

        <b-card-text>
          <div class="card">

            <div class="card-body">
              <h4 class="card-title">Pasta de Anexos</h4>
              <p class="card-title-desc">
                Pasta de Anexos do Movimento</p>

              <div class="table-responsive">
                <table class="table align-middle mb-0 table-nowrap">
                  <thead class="table-light">
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Descrição</th>
                    <th scope="col">Arquivo</th>
                    <th scope="col">Data</th>
                    <th scope="col">Ações</th>
                  </tr>
                  </thead>
                  <tbody>

                  <tr v-for="data in mediasAnexoData" :key="data.id">

                    <td>
                      <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.id }}
                              </span>
                      </h5>
                    </td>

                    <td>
                      {{ data.descricao }}
                    </td>

                    <td>
                        <span class="text-dark">
                          {{ data.nome }}
                        </span>
                    </td>

                    <td>
                      <h5 class="font-size-14 text-truncate">
                          <span class="text-dark">
                            {{ formatDateTime(data.created_at) }}
                          </span>
                      </h5>
                    </td>


                    <td>
                      <div class="button-items">

                        <b-button variant="outline-success" @click="downFile(data.path, data.nome)">
                          <i class="mdi mdi-download d-block font-size-16"></i>
                        </b-button>

                        <b-button variant="outline-danger" @click="delFile(data.id)"
                                  :disabled="data.email === 'admin@admin.com.br'">
                          <i class="mdi mdi-trash-can d-block font-size-16"></i>
                        </b-button>

                      </div>
                    </td>


                  </tr>

                  </tbody>
                </table>
              </div>

            </div>

          </div>


        </b-card-text>


        <div class="text-end mt-5">

          <b-button variant="light" @click="showModalAnexoList = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>

        </div>
      </div>

    </b-modal>


    <b-modal title="Alterar Modalidade de Frete" v-model="showModalFrete" centered hide-footer>


      <div class="col-md-12">

        <div class="row">
          <div class="col-sm-6">
            <div class="mb-3">
              <label for="frete">Tipo Frete</label>
              <select
                  id="frete"
                  v-model="movCompraData.frete"
                  class="form-control">
                <option value="CIF">CIF</option>
                <option value="FOB">FOB</option>
              </select>
            </div>
          </div>

          <div class="col-sm-6" v-if="movCompraData.frete === 'FOB'">
            <div class="mb-3">
              <label for="valorfrt">Favor informar o valor do frete</label>
              <input
                  id="valorfrt"
                  v-model="movCompraData.valorfrt"
                  type="number"
                  class="form-control"
                  placeholder="Valor do frete (R$)"/>
            </div>
          </div>
        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalFrete = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarFrete">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal title="Detalhes Conta" v-model="showModalFinConta" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="condpgto">Selecionar Nova Conta</label>

          <multiselect id="inputFinConta"
                       @search-change="pesqFinConta"
                       @select="escolheuFinConta"
                       v-model="movCompraData.finconta"
                       placeholder="Pesquisar plano de contas"
                       :options="dtListPesqFinConta"
                       :searchable="true"
                       label="descricao"
                       class="multiselect-size"
                       track-by="descricao"
                       value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>

                            <span class="text-info">
                              {{ slotProps.option.codigo }}
                            </span>
                  <span class="mx-4">
                              {{ slotProps.option.id }}
                            </span>
                </div>
                <div class="mt-2 font-size-16">{{ slotProps.option.descricao }}</div>
                <div class="align-items-end text-end align-content-end">{{ slotProps.option.nivel }}</div>
              </div>
            </template>
          </multiselect>

        </div>
      </div>

      <div class="row" v-if="loadingFinConta">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>


      <div v-if="!loadingFinConta && finContaData">
        <p class="mb-2">
          Tipo de Operação Atual
        </p>
        <!--        <router-link :to="`/tiposopera/list`" target="_blank" >-->
        <p class="mb-2">
          Código:
          <span class="text-primary"> {{ finContaData.codigo }} </span>
        </p>

        <p class="mb-2">
          Descrição:
          <span class="text-primary"> {{ finContaData.descricao }}  </span>
        </p>
        <!--        </router-link>-->


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalFinConta = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="showModalFinConta = false">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


<!--    <b-modal title="Detalhes Pagamento" v-model="showModalCondPgto" centered hide-footer>

      <div class="col-md-12 mt-2">
        <div class="mb-3">
          <span>Selecionar Nova Forma de Pagamento</span>

          <multiselect id="formapgto"
                       @search-change="pesqFormaPgto"
                       @select="escolheuFormaPgto"
                       v-model="movCompraData.formapgto"
                       placeholder="Pesquisar forma de pagamento"
                       :options="dtListPesqFormaPgto"
                       :searchable="true"
                       label="descricao"
                       track-by="descricao"
                       value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4">

                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                <span class="mx-4">
                </span>
                <span class="mx-4">
                </span>
                <div class="align-items-end text-end align-content-end">{{
                    formatDateTime(slotProps.option.created_at)
                  }}
                </div>

              </div>
            </template>
          </multiselect>

        </div>
      </div>

      <div class="col-md-12 mt-2">
        <div class="mb-3">
          <span>Selecionar Nova Condição de Pagamento</span>

          <multiselect id="condpgto"
                       @search-change="pesqCondPgto"
                       @select="escolheuCondPgto"
                       v-model="movCompraData.condpgto"
                       placeholder="Pesquisar condição de pagamento"
                       :options="dtListPesqCondPgto"
                       :searchable="true"
                       label="descricao"
                       track-by="descricao"
                       value-prop="codigo">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4">

                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>

                <span class="mx-4">

                </span>
                <span class="mx-4">

                  </span>
                <div class="align-items-end text-end align-content-end">{{
                    formatDateTime(slotProps.option.created_at)
                  }}
                </div>

              </div>
            </template>
          </multiselect>

        </div>
      </div>

      <div class="row" v-if="loadingCondPgto">
        <div class="col-12 text-center">
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
          <b-spinner type="grow"
                     class="m-6 mx-2"
                     variant="secondary"
                     role="status">
          </b-spinner>
        </div>
      </div>


      <div v-if="!loadingCondPgto && condPgtoData && formaPgtoData">


        <div class="mt-2">
          <p class="mb-2">
            Forma de Pagamento Atual
          </p>

          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ formaPgtoData.codigo }} </span>
          </p>

          <p class="mb-2">
            Descrição:
            <span class="text-primary"> {{ formaPgtoData.descricao }}  </span>
          </p>
        </div>


        <div class="mt-4">
          <p class="mb-2">
            Condição de Pagamento Atual
          </p>

          <p class="mb-2">
            Código:
            <span class="text-primary"> {{ condPgtoData.codigo }} </span>
          </p>

          <p class="mb-2">
            Descrição:
            <span class="text-primary"> {{ condPgtoData.descricao }}  </span>
          </p>
        </div>


        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalCondPgto = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarCondPgto">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>-->


    <b-modal title="Alterar Valor de Desconto" v-model="showModalDesconto" centered hide-footer>


      <div class="col-md-12">

        <div class="row">


          <div class="col-sm-12">
            <div class="mb-3">
              <label for="valordesconto">Valor Desconto</label>
              <input
                  id="valordesconto"
                  v-model="movCompraData.desconto"
                  type="number"
                  class="form-control"
                  placeholder="Valor Desconto"/>
            </div>
          </div>
        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalDesconto = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confirmarDesconto">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal title="Alterar Datas Movimento" v-model="showModalEmissao" centered hide-footer>

      <div class="row">
        <div class="col-md-12">
          <div class="mb-3">
            <label for="dtemissao">Data de Emissão</label>
            <input
                id="dtemissao"
                v-model="movCompraData.dtemissao"
                type="date"
                class="form-control"
                placeholder="Data de Emissão"/>
          </div>
        </div>
      </div>


      <div class="row">
        <div class="col-md-12">
          <div class="mb-3">
            <label for="dtmov">Data de Movimento</label>
            <input
                id="dtmov"
                v-model="movCompraData.dtmov"
                type="date"
                class="form-control"
                placeholder="Data de Movimento"/>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="text-end mt-5">
            <b-button variant="light" @click="showModalEmissao = false">
              <i class="bx bx-block font-size-16 align-middle me-2"></i>
              Cancelar
            </b-button>
            <b-button type="submit" variant="success" class="ms-1" @click="showModalEmissao = false">
              <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
              Confirmar
            </b-button>
          </div>
        </div>

      </div>
    </b-modal>


    <!--
      Pablo => Modal para cancelar uma nota
    -->
    <b-modal size="lg" title="Cancelamento de Nota Fiscal" v-model="showModalCancFocusNfe" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body d-flex" id="div-car-body">
            <form class="needs-validation">
              <div class="row justify-content-center">
                <div class="col-sm-6">
                  <label for="justificativa" class="text-center">Limite entre 15 a 255 caracteres</label>
                  <br>
                  <textarea v-model="justificativaCanc"
                            name="justificativa"
                            id="justificativa"
                            class="form-control"
                            cols="70"
                            rows="10"
                            placeholder="Justificativa"
                            minlength="15"
                            maxlength="255">
                  </textarea>
                </div>
              </div>

              <div class="row">
                <div class="text-end mt-5">
                  <b-button variant="light" @click="showModalCancFocusNfe = false">
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Voltar
                  </b-button>
                  <b-button type="button" variant="success" class="ms-1"
                            @click="confirmarCancFocusNfe(justificativaCanc)">
                    <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Confirmar
                  </b-button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </b-modal>

    <!--
      Pablo => Modal para envio de carta de correção
    -->
    <b-modal size="lg" title="Carta de correção de Nota Fiscal" v-model="showModalCorrFocusNfe" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body d-flex" id="div-car-body">
            <form class="needs-validation">
              <div class="row justify-content-center">
                <div class="col-sm-6">
                  <label for="correcao" class="text-center">Limite entre 15 a 1000 caracteres</label>
                  <br>
                  <textarea v-model="justificativaCorr"
                            name="correcao"
                            id="correcao"
                            class="form-control"
                            cols="70"
                            rows="10"
                            placeholder="Correção"
                            minlength="15"
                            maxlength="1000">
                  </textarea>
                </div>
              </div>

              <div class="row justify-content-center">
                <div class="text-end mt-5">
                  <b-button variant="light" @click="showModalCorrFocusNfe = false">
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Voltar
                  </b-button>
                  <b-button type="button" variant="success" class="ms-1" @click="confirmarCorrFocusNfe()">
                    <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Confirmar
                  </b-button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </b-modal>

    <!--
      Pablo => Modal para confirmação do tipo de pesquisa
    -->
    <b-modal
        v-model="tipoConsultaFocusNFe"
        id="modal-center"
        centered
        title="Escolha o tipo de consulta desejado"
        title-class="font-18"
        hide-footer
    >
      <p>Qual tipo de consulta você deseja realizar?</p>

      <div class="text-center">
        <div class=" d-inline" :style="{'margin-right': '10px'}">
          <b-button variant="secondary" @click="consultarFocusNFe(0)">Simplificada</b-button>
        </div>
        <div class=" d-inline" :style="{'margin-left': '10px'}">
          <b-button variant="secondary" @click="consultarFocusNFe(1)">Completa</b-button>
        </div>
      </div>
    </b-modal>


    <!--
      Pablo => Modal para retorno simplificado modalConsultaSimplificada | retornoConsultaFocusNFe
    -->
    <b-modal
        v-model="modalConsultaSimplificada"
        id="modal-xl"
        size="xl"
        title="Status da Nota fiscal"
        title-class="font-18"
        hide-footer
        @hide="atualizaPagina"
    >
      <table class="table">
        <tbody>
        <template v-for="(value, key) in retornoConsultaFocusNFe" :key="key">
          <tr>
            <td>{{ key }}</td>
            <td>
              <template v-if="typeof value === 'object'">
                <table class="table">
                  <tbody>
                  <tr v-for="(subValue, subKey) in value" :key="subKey">
                    <td>{{ subKey }}</td>
                    <td>{{ subValue }}</td>
                  </tr>
                  </tbody>
                </table>
              </template>
              <template v-else>
                {{ value }}
              </template>
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </b-modal>


    <!--
      Pablo => Modal para retorno do envio/reenvio da nota fiscal | modalRetornoEnvioFocusnfe
    -->
    <b-modal
        v-model="modalRetornoEnvioFocusnfe"
        id="modal-xl"
        size="xl"
        title="Status da Nota fiscal"
        title-class="font-18"
        hide-footer
        @hide="atualizaPagina"
    >


      <table class="table">
        <tbody>
        <tr v-for="(value, key) in retornoConsultaFocusNFe" :key="key">
          <td>{{ key }}</td>
          <td>{{ value }}</td>
        </tr>
        </tbody>
      </table>
    </b-modal>

    <b-modal
        v-model="showEspelhoNf"
        id="modal-xl"
        size="xl"
        title="Espelho da NF-e Compra"
        title-class="font-18"
        hide-footer
    >


      <div class="card">
        <div class="card-body">
          <b-form>
            <b-form-group
                class="mb-3"
                label="Natureza da operação [Tag natOp]"
                label-for="pedtipodescricao"
            >
              <b-form-input
                  id="pedtipodescricao"
                  type="text"
                  v-model="naturezaData.descricao"
                  readonly
              ></b-form-input>
            </b-form-group>

            <br>
            <div class="row">
              <h4>Informações gerais da nota</h4>
              <div class="col-md-2">
                <b-form-group
                    class="mb-3"
                    label="Desconto"
                    label-for="movCompraDatadesconto"
                >
                  <b-form-input
                      id="movCompraDatadesconto"
                      type="text"
                      v-model="movCompraData.desconto"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-1">
                <b-form-group
                    class="mb-3"
                    label="finNFe"
                    title="Finalidade da nota fiscal."
                    label-for="movCompraDatafinnfe"
                >
                  <b-form-input
                      id="movCompraDatafinnfe"
                      type="text"
                      readonly
                      v-model="movCompraData.finnfe"
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-2">
                <b-form-group
                    class="mb-3"
                    label="Frete"
                    label-for="movCompraDatafrete"
                >
                  <b-form-input
                      id="movCompraDatafrete"
                      type="text"
                      v-model="movCompraData.frete"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-3">
                <b-form-group
                    class="mb-3"
                    label="Local destino [idDest]"
                    title="Identificador de local de destino da operação"
                    label-for="movCompraDataiddest"
                >

                  <select
                      id="movCompraDataiddest"
                      v-model="movCompraData.iddest"
                      class="form-control">
                    <option value="1">[1] Operação interna</option>
                    <option value="2">[2] Operação interestadual</option>
                    <option value="3">[2] Operação com exterior</option>
                  </select>

                </b-form-group>
              </div>


              <div class="col-md-2">
                <b-form-group
                    class="mb-3"
                    label="indFinal"
                    title="Indica operação com consumidor final"
                    label-for="movCompraDataindfinal"
                >

                  <select
                      id="movCompraDataindfinal"
                      v-model="movCompraData.indfinal"
                      class="form-control">
                    <option value="0">[0] Normal</option>
                    <option value="1">[1] Consumidor final</option>
                  </select>
                </b-form-group>
              </div>


              <div class="col-md-4">
                <b-form-group
                    class="mb-3"
                    label="Presença [indPres]"
                    title="Indicador de presença do comprador no estabelecimento comercial no momento da operação"
                    label-for="movCompraDataindpres"
                >
                  <select
                      id="movCompraDataindpres"
                      v-model="movCompraData.indpres"
                      class="form-control">
                    <option value="0">[0] Não se aplica (por exemplo, para a Nota Fiscal complementar ou de ajuste)
                    </option>
                    <option value="1">[1] Operação presencial</option>
                    <option value="2">[2] Operação não presencial, pela Internet</option>
                    <option value="3">[3] Operação não presencial, Teleatendimento</option>
                    <option value="4">[4] NFC-e em operação com entrega em domicílio</option>
                    <option value="5">[5] Operação presencial, fora do estabelecimento</option>
                    <option value="9">[9] Operação não presencial, outros</option>
                  </select>
                </b-form-group>
              </div>


              <div class="col-md-2">
                <b-form-group
                    class="mb-3"
                    label="Valor Bruto"
                    label-for="movCompraDatavalorbrt"
                >
                  <b-form-input
                      id="movCompraDatavalorbrt"
                      type="text"
                      v-model="movCompraData.valorbrt"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-2">
                <b-form-group
                    class="mb-3"
                    label="Valor líquido"
                    label-for="movCompraDatavalorliq"
                >
                  <b-form-input
                      id="movCompraDatavalorliq"
                      type="text"
                      v-model="movCompraData.valorliq"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-2">
                <b-form-group
                    class="mb-3"
                    label="Peso"
                    label-for="movCompraDatapeso"
                >
                  <b-form-input
                      id="movCompraDatapeso"
                      type="text"
                      v-model="movCompraData.peso"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>

            <hr>
            <div class="row">
              <h4>Informações do fornecedor</h4>

              <div class="col-md-5">
                <b-form-group
                    class="mb-3"
                    label="Nome"
                    label-for="fornecedorDatanome"
                >
                  <b-form-input
                      id="fornecedorDatanome"
                      type="text"
                      v-model="fornecedorData.nome"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-2">
                <b-form-group
                    class="mb-3"
                    label="CNPJ | CPF"
                    label-for="fornecedorDatacnpj"
                >
                  <b-form-input
                      id="fornecedorDatacnpj"
                      type="text"
                      v-model="fornecedorData.cnpj"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-2">
                <b-form-group
                    class="mb-3"
                    label="Inscrição"
                    label-for="fornecedorDatainscricao"
                >
                  <b-form-input
                      id="fornecedorDatainscricao"
                      type="text"
                      v-model="fornecedorData.inscricao"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-1">
                <b-form-group
                    class="mb-3"
                    label="UF"
                    label-for="fornecedorDataestado"
                >
                  <b-form-input
                      id="fornecedorDataestado"
                      type="text"
                      v-model="fornecedorData.estado"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-2">
                <b-form-group
                    class="mb-3"
                    label="CEP"
                    label-for="fornecedorDatacep"
                >
                  <b-form-input
                      id="fornecedorDatacep"
                      type="text"
                      v-model="fornecedorData.cep"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-3">
                <b-form-group
                    class="mb-3"
                    label="Cidade"
                    label-for="fornecedorDatacidade"
                >
                  <b-form-input
                      id="fornecedorDatacidade"
                      type="text"
                      v-model="fornecedorData.cidade"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-3">
                <b-form-group
                    class="mb-3"
                    label="Bairro"
                    label-for="fornecedorDatabairro"
                >
                  <b-form-input
                      id="fornecedorDatabairro"
                      type="text"
                      v-model="fornecedorData.bairro"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>


              <div class="col-md-5">
                <b-form-group
                    class="mb-3"
                    label="Logradouro"
                    label-for="fornecedorDatarua"
                >
                  <b-form-input
                      id="fornecedorDatarua"
                      type="text"
                      v-model="fornecedorData.rua"
                      readonly
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>

            <hr>
            <h4>Informações do Produto</h4>
            <div v-for="item in movCompraItensEspelho" :key="item.id">
              <div class="row">
                <div class="col-md-7">
                  <b-form-group
                      class="mb-3"
                      label="Nome"
                      label-for="movcompraitemdescprod"
                  >
                    <b-form-input
                        id="movcompraitemdescprod"
                        type="text"
                        v-model="item.descprod"
                        readonly
                    ></b-form-input>
                  </b-form-group>
                </div>


                <div class="col-md-5">
                  <b-form-group
                      class="mb-3"
                      label="EAN"
                      label-for="movcompraitemproduto"
                  >
                    <b-form-input
                        id="movcompraitemproduto"
                        type="text"
                        v-model="item.produto"
                        readonly
                    ></b-form-input>
                  </b-form-group>
                </div>


                <div class="col-md-2">
                  <b-form-group
                      class="mb-3"
                      label="CFOP"
                      label-for="movcompraitemcfop"
                  >
                    <b-form-input
                        id="movcompraitemcfop"
                        type="text"
                        v-model="item.cfop"
                    ></b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-2">
                  <b-form-group
                      class="mb-3"
                      label="Desconto"
                      label-for="movcompraitemdesconto"
                  >
                    <b-form-input
                        id="movcompraitemdesconto"
                        type="text"
                        v-model="item.desconto"
                        readonly
                    ></b-form-input>
                  </b-form-group>
                </div>


                <div class="col-md-1">
                  <b-form-group
                      class="mb-3"
                      label="Qtdade"
                      label-for="movcompraitemqtd"
                  >
                    <b-form-input
                        id="movcompraitemqtd"
                        type="text"
                        v-model="item.qtd"
                        readonly
                    ></b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-1">
                  <b-form-group
                      class="mb-3"
                      label="Unidade"
                      label-for="movcompraitemund"
                  >
                    <b-form-input
                        id="movcompraitemund"
                        type="text"
                        v-model="item.und"
                        readonly
                    ></b-form-input>
                  </b-form-group>
                </div>


                <div class="col-md-2">
                  <b-form-group
                      class="mb-3"
                      label="R$ Total"
                      label-for="movcompraitemvlrtotalliq"
                  >
                    <b-form-input
                        id="movcompraitemvlrtotalliq"
                        type="text"
                        v-model="item.vlrtotalliq"
                        readonly
                    ></b-form-input>
                  </b-form-group>
                </div>


                <div class="col-md-2">
                  <b-form-group
                      class="mb-3"
                      label="R$ Unitário"
                      label-for="movcompraitemvlrunitliq"
                  >
                    <b-form-input
                        id="movcompraitemvlrunitliq"
                        type="text"
                        v-model="item.vlrunitliq"
                        readonly
                    ></b-form-input>
                  </b-form-group>
                </div>


                <div class="col-md-3">
                  <b-form-group
                      class="mb-3"
                      label="Sit. trib. ICMS [cst]"
                      label-for="movcompraitemicmscst"
                  >

                    <select id="movcompraitemicmscst" v-model="item.icmscst" class="form-control" required>
                      <option value="00">[00] tributada integralmente</option>
                      <option value="02">[02] tributação monofásica própria sobre combustíveis</option>
                      <option value="10">[10] tributada e com cobrança do ICMS por substituição tributária</option>
                      <option value="10_partilha">[10_partilha] tributada e com cobrança do ICMS por substituição
                        tributária. Operação interestadual para consumidor final com partilha do ICMS devido na operação
                        entre a UF de origem e a do destinatário, ou a UF definida na legislação. (Ex. UF da
                        concessionária de entrega do veículo)
                      </option>
                      <option value="15">[15] tributação monofásica própria e com responsabilidade pela retenção sobre
                        combustíveis
                      </option>
                      <option value="20">[20] tributada com redução de base de cálculo</option>
                      <option value="30">[30] isenta ou não tributada e com cobrança do ICMS por substituição
                        tributária
                      </option>
                      <option value="40">[40] isenta</option>
                      <option value="41">[41] não tributada</option>
                      <option value="41_st">[41_st] não tributada com ICMS ST devido para a UF de destino, nas operações
                        interestaduais de produtos que tiveram retenção antecipada de ICMS por ST na UF do remetente.
                        Repasse via Substituto Tributário.
                      </option>
                      <option value="50">[50] suspensão</option>
                      <option value="51">[51] diferimento (a exigência do preenchimento das informações do ICMS diferido
                        fica a critério de cada UF)
                      </option>
                      <option value="53">[53] tributação monofásica sobre combustíveis com recolhimento diferido
                      </option>
                      <option value="60">[60] cobrado anteriormente por substituição tributária</option>
                      <option value="60_st">[60_st] cobrado anteriormente por substituição tributária com ICMS ST devido
                        para a UF de destino, nas operações interestaduais de produtos que tiveram retenção antecipada
                        de ICMS por ST na UF do remetente. Repasse via Substituto Tributário.
                      </option>
                      <option value="61">[61] tributação monofásica sobre combustíveis cobrada anteriormente</option>
                      <option value="70">[70] tributada com redução de base de cálculo e com cobrança do ICMS por
                        substituição tributária
                      </option>
                      <option value="90">[90] outras (regime Normal)</option>
                      <option value="90_partilha">[90_partilha] outras (regime Normal). Operação interestadual para
                        consumidor final com partilha do ICMS devido na operação entre a UF de origem e a do
                        destinatário, ou a UF definida na legislação. (Ex. UF da concessionária de entrega do veículo)
                      </option>
                      <option value="101">[101] tributada pelo Simples Nacional com permissão de crédito</option>
                      <option value="102">[102] tributada pelo Simples Nacional sem permissão de crédito</option>
                      <option value="103">[103] isenção do ICMS no Simples Nacional para faixa de receita bruta</option>
                      <option value="201">[201] tributada pelo Simples Nacional com permissão de crédito e com cobrança
                        do ICMS por substituição tributária
                      </option>
                      <option value="202">[202] tributada pelo Simples Nacional sem permissão de crédito e com cobrança
                        do ICMS por substituição tributária
                      </option>
                      <option value="203">[203] isenção do ICMS nos Simples Nacional para faixa de receita bruta e com
                        cobrança do ICMS por substituição tributária
                      </option>
                      <option value="300">[300] imune</option>
                      <option value="400">[400] não tributada pelo Simples Nacional</option>
                      <option value="500">[500] ICMS cobrado anteriormente por substituição tributária (substituído) ou
                        por antecipação
                      </option>
                      <option value="900">[900] outras (regime Simples Nacional)</option>
                    </select>
                  </b-form-group>
                </div>


                <div class="col-md-3">
                  <b-form-group
                      class="mb-3"
                      label="ICMS origem [ori]"
                      label-for="movcompraitemicmsori"
                  >
                    <select
                        id="movcompraitemicmsori"
                        v-model="item.icmsori"
                        class="form-control">
                      <option value="0">[0] nacional</option>
                      <option value="1">[1] estrangeira (importação direta)</option>
                      <option value="2">[2] estrangeira (adquirida no mercado interno)</option>
                      <option value="3">[3] nacional com mais de 40% de conteúdo estrangeiro</option>
                      <option value="4">[4] nacional produzida através de processos produtivos básicos</option>
                      <option value="5">[5] nacional com menos de 40% de conteúdo estrangeiro</option>
                      <option value="6">[6] estrangeira (importação direta) sem produto nacional similar</option>
                      <option value="7">[7] estrangeira (adquirida no mercado interno) sem produto nacional similar
                      </option>
                      <option value="8">[8] nacional, mercadoria ou bem com Conteúdo de Importação superior a 70%
                      </option>
                    </select>
                  </b-form-group>
                </div>


                <div class="col-md-3">
                  <b-form-group
                      class="mb-3"
                      label="Sit. trib. PIS [cst]"
                      label-for="movcompraitempiscst"
                  >

                    <select id="movcompraitempiscst" v-model="item.piscst" class="form-control" required>
                      <option value="01">[01] operação tributável: base de cálculo = valor da operação (alíquota normal
                        - cumulativo/não cumulativo)
                      </option>
                      <option value="02">[02] operação tributável: base de cálculo = valor da operação (alíquota
                        diferenciada)
                      </option>
                      <option value="03">[03] operação tributável: base de cálculo = quantidade vendida × alíquota por
                        unidade de produto
                      </option>
                      <option value="04">[04] operação tributável: tributação monofásica (alíquota zero)</option>
                      <option value="05">[05] operação tributável: substituição tributária</option>
                      <option value="06">[06] operação tributável: alíquota zero</option>
                      <option value="07">[07] operação isenta da contribuição</option>
                      <option value="08">[08] operação sem incidência da contribuição</option>
                      <option value="09">[09] operação com suspensão da contribuição</option>
                      <option value="49">[49] outras operações de saída</option>
                      <option value="50">[50] operação com direito a crédito: vinculada exclusivamente a receita
                        tributada no mercado interno
                      </option>
                      <option value="51">[51] operação com direito a crédito: vinculada exclusivamente a receita não
                        tributada no mercado interno
                      </option>
                      <option value="52">[52] operação com direito a crédito: vinculada exclusivamente a receita de
                        exportação
                      </option>
                      <option value="53">[53] operação com direito a crédito: vinculada a receitas tributadas e
                        não-tributadas no mercado interno
                      </option>
                      <option value="54">[54] operação com direito a crédito: vinculada a receitas tributadas no mercado
                        interno e de exportação
                      </option>
                      <option value="55">[55] operação com direito a crédito: vinculada a receitas não-tributadas no
                        mercado interno e de exportação
                      </option>
                      <option value="56">[56] operação com direito a crédito: vinculada a receitas tributadas e
                        não-tributadas no mercado interno e de exportação
                      </option>
                      <option value="60">[60] crédito presumido: operação de aquisição vinculada exclusivamente a
                        receita tributada no mercado interno
                      </option>
                      <option value="61">[61] crédito presumido: operação de aquisição vinculada exclusivamente a
                        receita não-tributada no mercado interno
                      </option>
                      <option value="62">[62] crédito presumido: operação de aquisição vinculada exclusivamente a
                        receita de exportação
                      </option>
                      <option value="63">[63] crédito presumido: operação de aquisição vinculada a receitas tributadas e
                        não-tributadas no mercado interno
                      </option>
                      <option value="64">[64] crédito presumido: operação de aquisição vinculada a receitas tributadas
                        no mercado interno e de exportação
                      </option>
                      <option value="65">[65] crédito presumido: operação de aquisição vinculada a receitas
                        não-tributadas no mercado interno e de exportação
                      </option>
                      <option value="66">[66] crédito presumido: operação de aquisição vinculada a receitas tributadas e
                        não-tributadas no mercado interno e de exportação
                      </option>
                      <option value="67">[67] crédito presumido: outras operações</option>
                      <option value="70">[70] operação de aquisição sem direito a crédito</option>
                      <option value="71">[71] operação de aquisição com isenção</option>
                      <option value="72">[72] operação de aquisição com suspensão</option>
                      <option value="73">[73] operação de aquisição a alíquota zero</option>
                      <option value="74">[74] operação de aquisição sem incidência da contribuição</option>
                      <option value="75">[75] operação de aquisição por substituição tributária</option>
                      <option value="98">[98] outras operações de entrada</option>
                      <option value="99">[99] outras operações</option>
                    </select>
                  </b-form-group>
                </div>


                <div class="col-md-3">
                  <b-form-group
                      class="mb-3"
                      label="Sit. trib. Cofins [cst]"
                      label-for="movcompraitemcofinscst"
                  >

                    <select id="movcompraitemcofinscst" v-model="item.cofinscst" class="form-control" required>
                      <option value="01">[01] operação tributável: base de cálculo = valor da operação (alíquota normal
                        - cumulativo/não cumulativo)
                      </option>
                      <option value="02">[02] operação tributável: base de cálculo = valor da operação (alíquota
                        diferenciada)
                      </option>
                      <option value="03">[03] operação tributável: base de cálculo = quantidade vendida × alíquota por
                        unidade de produto
                      </option>
                      <option value="04">[04] operação tributável: tributação monofásica (alíquota zero)</option>
                      <option value="05">[05] operação tributável: substituição tributária</option>
                      <option value="06">[06] operação tributável: alíquota zero</option>
                      <option value="07">[07] operação isenta da contribuição</option>
                      <option value="08">[08] operação sem incidência da contribuição</option>
                      <option value="09">[09] operação com suspensão da contribuição</option>
                      <option value="49">[49] outras operações de saída</option>
                      <option value="50">[50] operação com direito a crédito: vinculada exclusivamente a receita
                        tributada no mercado interno
                      </option>
                      <option value="51">[51] operação com direito a crédito: vinculada exclusivamente a receita não
                        tributada no mercado interno
                      </option>
                      <option value="52">[52] operação com direito a crédito: vinculada exclusivamente a receita de
                        exportação
                      </option>
                      <option value="53">[53] operação com direito a crédito: vinculada a receitas tributadas e
                        não-tributadas no mercado interno
                      </option>
                      <option value="54">[54] operação com direito a crédito: vinculada a receitas tributadas no mercado
                        interno e de exportação
                      </option>
                      <option value="55">[55] operação com direito a crédito: vinculada a receitas não-tributadas no
                        mercado interno e de exportação
                      </option>
                      <option value="56">[56] operação com direito a crédito: vinculada a receitas tributadas e
                        não-tributadas no mercado interno e de exportação
                      </option>
                      <option value="60">[60] crédito presumido: operação de aquisição vinculada exclusivamente a
                        receita tributada no mercado interno
                      </option>
                      <option value="61">[61] crédito presumido: operação de aquisição vinculada exclusivamente a
                        receita não-tributada no mercado interno
                      </option>
                      <option value="62">[62] crédito presumido: operação de aquisição vinculada exclusivamente a
                        receita de exportação
                      </option>
                      <option value="63">[63] crédito presumido: operação de aquisição vinculada a receitas tributadas e
                        não-tributadas no mercado interno
                      </option>
                      <option value="64">[64] crédito presumido: operação de aquisição vinculada a receitas tributadas
                        no mercado interno e de exportação
                      </option>
                      <option value="65">[65] crédito presumido: operação de aquisição vinculada a receitas
                        não-tributadas no mercado interno e de exportação
                      </option>
                      <option value="66">[66] crédito presumido: operação de aquisição vinculada a receitas tributadas e
                        não-tributadas no mercado interno e de exportação
                      </option>
                      <option value="67">[67] crédito presumido: outras operações</option>
                      <option value="70">[70] operação de aquisição sem direito a crédito</option>
                      <option value="71">[71] operação de aquisição com isenção</option>
                      <option value="72">[72] operação de aquisição com suspensão</option>
                      <option value="73">[73] operação de aquisição a alíquota zero</option>
                      <option value="74">[74] operação de aquisição sem incidência da contribuição</option>
                      <option value="75">[75] operação de aquisição por substituição tributária</option>
                      <option value="98">[98] outras operações de entrada</option>
                      <option value="99">[99] outras operações</option>
                    </select>
                  </b-form-group>
                </div>
              </div>
            </div>

            <hr>
            <div class="row">
              <h4>Informações adicionais da nota</h4>
              <div class="col-md-10">
                <b-form-group
                    class="mb-3"
                    label="Informações complementares"
                    label-for="movCompraDataobs"
                >
                  <b-form-input
                      id="movCompraDataobs"
                      type="text"
                      v-model="movCompraData.obs"
                  ></b-form-input>
                </b-form-group>
              </div>
            </div>
            <br><br>

            <div class="justify-content-center">
              <b-button variant="success" @click="updateMovCompra">Atualizar dados</b-button>
              <b-button variant="error" @click="showEspelhoNf = false">Fechar</b-button>
            </div>
          </b-form>
        </div>
      </div>
    </b-modal>
    <b-modal
      size="md"
      :title="Prod != null ? `Ações -  (Item: ${Prod}) ` : 'Ações'"
      v-model="showModalAcao"
      centered
      hide-footer
    >
      <div class="d-flex col-10 justify-content-between mt-2 mb-2">
        <b-button
          variant="outline-success"
          class="action-icon text-success mx-2"
          @click="detalhesProduto(idProd)"
        >
          <i class="mdi mdi-eye font-size-18"></i>
          Detalhes
        </b-button>

        <b-button
          variant="outline-warning"
          v-if="movCompraData.status === 'EL'"
          class="action-icon text-warning mx-2"
          @click="editarProduto(idRow)"
        >
          <i class="mdi mdi-pencil-outline font-size-18"></i>
          Editar
        </b-button>

        <b-button
          variant="outline-danger"
          v-if="movCompraData.status === 'EL'"
          class="action-icon text-danger mx-2"
          @click="deletarMovCompraItem(idRow)"
        >
          <i class="mdi mdi-trash-can font-size-18"></i>
          Deletar
        </b-button>
      </div>
    </b-modal>
  </Layout>
</template>


<style>
.multiselect-size {
  --ms-max-height: 500px;
}
</style>
